import "./productReport.css";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import { useAuthHeader } from "react-auth-kit";
import { useGlobalContext } from "../../context/global";
import SectionTitle from "../../components/sectionTitle";
import { isPlatformMatch } from "../../helper/Reports/common";
import Loader from "../../components/loader";
import useInitialLoad from "../../hooks/useInitialLoad";
import leftArrow from '../../assets/icons/left-arrow.svg'
import { getCustomReportKeyByPage, getSearchParamsObject, saveCustomReportByKey, updateCustomReportById, formatDate, getComparisonFormatTimeDimension } from "../../components/Reports/Components/utils";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { ALL_WEEK_DAYS, customDateToTimePeriod, defaultDimensions, getCubeFiltersByActionType, getComparisonPercentageFiltersRuleTree, mergeCustomOutputToAPIFiltersFormatWithComparisonPercentage, removeRuleItemByMember, reverseMergeAPIFiltersToFilterModuleFormat, ruleItemInjector, transformToTopXArray } from "../../helper/Quadrant/quadrantHelper";
import { FiltersCampaignDataQuadrant, FiltersDimensionDataQuadrant, FiltersMeasuresDataQuadrant, GroupByOptionsDataConfig, PlatformWiseKeyMapper, PlatformWiseQueryDefaultDimension, PlatformWiseQueryMeasures, PlatformWiseQueryOrder, useTopXDataConfig } from "../../components/Filter/FilterData/quadrantFilter";
import StopLossFilters from "../StopLossList/subComponents/StopLossFilters/StopLossFilters";
import { processFields } from "../../components/Filter/subComponents/filterHelper";
import { DYNAMIC_SECTION_PAGES, PAGE_TYPE_CONSTANTS } from "../../constant/productAnalytics/productReportConfigs";
import ProductSetFilters from "../productSets/subComponents/ProductSetFilters";
import checkDuplicateStringInArray from "../../helper/common/checkDuplicateStringinArray";
import { openRequestTrackingPage } from "../../helper/common/openRequestTrackingPage";
import { PRODUCT_SET_REFRESH_DURATION } from "../../constant/productset/productsetconfig";
import useUserDetails from "../../helper/userData/useUserDetails";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import ComplexFilterWidget from "../../components/Filter/ComplexFilterWidget";
import ProductAnalyticsTable from "./ProductAnalyticsTable/ProductAnalyticsTable";
import {
  getAllColumns,
  getMappedCustomAttributeLabel,
} from "../../components/Filter/FilterData/columnConfig";
import CloseIcon from "@mui/icons-material/Close";
import { Autocomplete, Badge, Box, Button, Checkbox, FormControl, FormControlLabel, CircularProgress, IconButton, InputAdornment, InputBase, Menu, MenuItem, Popover, Select, Stack, Switch, TextField, ToggleButton, Tooltip, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ArrowDropDown, ArrowDropUp, FilterAlt, FilterAltOutlined, FileDownloadOutlined, FileUploadOutlined, OpenInNewOutlined, ViewList, BarChart } from "@mui/icons-material";
import BulkActionBarV2 from "../../components/Bars/BulkActionBarV2";
import BulkActionConfirmModalV2 from "../../components/modal/BulkActionConfirmModalV2";
import CSVUploadModal from "../../components/modal/campaignListModals/csvUploadModal/csvUploadModal";
import PopulateProductAdsV2 from "../../components/modal/PopulateProductAdsV2";
import { campaignListActions } from "../../redux/slices/campaignList";
import { buildBulkQuery } from "../../helper/bulkSelection/buildBulkQuery";
import {
  BULK_SCOPE,
  applyBulkRowToggle,
  applyBulkSelectAllPage,
  applySelectAllMatching,
  clearBulkSelection,
  getRowBulkId,
  getSelectedRowIds,
  shouldShowSelectAllMatchingBanner,
  syncRowsWithBulkScope,
} from "../../helper/bulkSelection/bulkSelectionModes";
import {
  POPULATE_LEVEL,
  PRODUCT_ANALYTICS_CUBE,
  PRODUCT_ANALYTICS_GRAIN,
  buildBulkAdStatusPatchBody,
  getProductAnalyticsBulkIdKeys,
  getProductAnalyticsGrain,
  getRequestedCountForBulk,
  isAdStatusEnabled,
  isChildAsinInGroupBy,
  shouldCreateMissingByDefault,
  submitBulkAdPopulate,
  submitBulkAdStatusUpdate,
  buildBulkAdPopulateBody,
} from "../../helper/bulkSelection/bulkProductAdUpdate";
import PlatformFetchStatus from "../../components/PlatformFetchStatus/PlatformFetchStatus";
import AmazonIcon from "../../assets/svgs/amazon.svg";
import MyntraIcon from "../../assets/svgs/myntra.svg";
import FlipkartIcon from "../../assets/svgs/flipkart.svg";
import AdyogiIcon from "../../assets/images/Adyogi_logoz.svg";
import { handleDownloadAllProductData } from "../../components/Reports/Components/ProductAnalyticsDownload";
import ExportDownloadTooltip, {
  EXPORT_LIMIT_TOOLTIP_MESSAGE,
  EXPORT_TRACK_TOOLTIP_MESSAGE,
  getExportRedirectIconButtonSx,
} from "../../components/Reports/Components/ExportDownloadTooltip";
import QuadrantView from "../QuadrantView/QuadrantView";
import { List, PieChartOutlined } from "@mui/icons-material";
import AppliedFiltersChips from "../../components/Filter/AppliedFiltersChips";
import {
  ColumnCustomizationButton,
  COLUMN_CUSTOMIZATION_PAGE_IDS,
  CUSTOM_VIEW_TYPE,
  DEFAULT_CUSTOM_VIEW_ID,
  buildCustomCollections,
  buildStandardCollections,
  createNamedCustomView,
  deleteCustomViewOnPage,
  getMetricColumns,
  getMetricKeysForView,
  getDefaultCustomSeedKeys,
  getPageColumnCustomization,
  getVisibleColumns,
  renameCustomViewOnPage,
  resolveInitialColumnState,
  upsertCustomViewOnPage,
} from "../../components/ColumnCustomization";
import {
  QuickFilterButton,
  QUICK_FILTER_PAGE_IDS,
} from "../../components/QuickFilter";

const PAGE_SIZE_OPTIONS = [50, 100, 200, 300, 500];
const MAX_GROUP_BY_DIMENSION_COLUMNS = 6;
const VIEW_TYPE_OPTIONS = [
  { label: "Performance View", value: "PERFORMANCE" },
  { label: "Funnel View", value: "FUNNEL" },
  { label: "Order View", value: "ORDER" },
  { label: "Aggregate View", value: "AGGREGATE" },
];
const PRODUCT_SET_SKU_DIMENSION = "VariantAnalysisTablePPMPlaceholder.sku";

function getProductAdStatusScopeNote(grain, isEnable) {
  const action = isEnable ? "enable" : "pause";
  switch (grain) {
    case PRODUCT_ANALYTICS_GRAIN.ASIN_ONLY:
      return isEnable
        ? "This will enable existing ads in all campaigns and all ad groups for the selected products. Missing ads will not be created."
        : "This will pause existing ads in all campaigns and all ad groups for the selected products.";
    case PRODUCT_ANALYTICS_GRAIN.CAMPAIGN:
      return isEnable
        ? "This will enable ads in all ad groups of the selected campaign(s). Missing ads will be created in those ad groups."
        : "This will pause ads in all ad groups of the selected campaign(s).";
    case PRODUCT_ANALYTICS_GRAIN.AD_GROUP:
      return isEnable
        ? "This will enable ads only in the selected campaign and ad group. Missing ads will be created there."
        : "This will pause ads only in the selected campaign and ad group.";
    case PRODUCT_ANALYTICS_GRAIN.PORTFOLIO:
      return isEnable
        ? null
        : "This will pause existing ads in all campaigns and ad groups in the selected portfolio(s).";
    default:
      return `This will ${action} ads for the selected products.`;
  }
}

const ensureProductSetSkuDimension = (
  dimensions = [],
  { isProductSetPage, userPlatform } = {}
) => {
  if (
    isProductSetPage &&
    userPlatform === "amazon" &&
    !dimensions.includes(PRODUCT_SET_SKU_DIMENSION)
  ) {
    return [...dimensions, PRODUCT_SET_SKU_DIMENSION];
  }
  return [...dimensions];
};

const buildProductAnalyticsSearch = ({
  reportType,
  viewtype,
  analysisDimensions,
  page,
  extraParams = {},
} = {}) => {
  const queryParams = new URLSearchParams();
  if (reportType) queryParams.set("reportType", reportType);
  if (viewtype) queryParams.set("viewtype", viewtype);
  const dimensionsParam = Array.isArray(analysisDimensions)
    ? analysisDimensions.filter(Boolean).join(",")
    : analysisDimensions;
  if (dimensionsParam) {
    queryParams.set("analysisDimensions", dimensionsParam);
  }
  if (page) queryParams.set("page", page);
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      queryParams.set(key, value);
    }
  });
  return queryParams.toString();
};

const ProductReport = (props) => {
  const {
    calendarDate,
    setCalendarDate,
    dateDifference,
    setDateDifference,
    applyCalendar,
    multiCalendarDate,
    clientId,
    cursorData,
    setCursorData,
    setHeaderCalendarHandleComparisonView,
    setHeaderCalendarHideComparisonSwitch,
    refreshCustomSavedReports,
    customSavedReports,
    columnCustomizationConfig,
    setColumnCustomizationConfig,
  } = useGlobalContext();
  
  const dashboardSideBarVisibiltyState = useSelector(
    (state) => state.dashboardData.dashboardSideBarVisibiltyState
  );
  const csvUploadModalInGlobalAd = useSelector(
    (state) => state.campaignListData.csvUploadModalInGlobalAd
  );
  const dispatch = useDispatch();
  const authHeader = useAuthHeader();
  const navigate = useNavigate();
  const location = useLocation();

  const allParams = new URLSearchParams(location.search);
  const paramsObject = getSearchParamsObject(allParams);
  const savedReportId = allParams.get("savedReportId");
  const [urlQuery, setUrlQuery] = useState(paramsObject?.urlQuery);
  let pslRuleId = paramsObject?.pslRuleId;
  let productsetId = paramsObject?.productsetId;
  let pageType = paramsObject?.page;
  const  TopXDataConfig = useTopXDataConfig();
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  const isStopLossPage = pageType === 'stoploss' ?? false;
  const isProductSetPage = pageType === 'productset' ?? false;
  const isPageUnderDynamicSection = DYNAMIC_SECTION_PAGES?.includes(pageType) ?? false
  const pageTypeConstantHeading = PAGE_TYPE_CONSTANTS[pageType]?.heading ?? '' 
  const viewTYPE =allParams.get('viewtype') ?? 'PERFORMANCE';
  const [isComparisonView, setisComparisonView] = useState(allParams.get('isComparisonView') ?? false);
 

  const stopLossConfigRule = {
    name: '',
    recommend_only: false,
    frequency: "Daily",
    max_percent_exclude: 50,
    stoploss_running_days: ALL_WEEK_DAYS,
  }

  const STOP_LOSS_RULE_TYPE = {
    amazon: "AMAZON_STOP_LOSS",
    flipkart: "FLIPKART_STOP_LOSS",
    myntra: "MYNTRA_STOP_LOSS",
  };
  // decode the urlQuery and parse it into json
  // const previousFiltering = objectoFiltering(paramsObject,"VariantAnalysisTablePPMPlaceholder")
  const [currentViewType, setCurrentViewType] = useState(viewTYPE);
  const [showCustomDateBox, setShowCustomDateBox] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { cubeToken, setCubeToken } = useGlobalContext();
  let startDate = formatDate(multiCalendarDate.selection1.startDate);
  let endDate = formatDate(multiCalendarDate.selection1.endDate);
  let startDatePrevious = formatDate(
        multiCalendarDate.selection2.startDate
      );
  let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
  const cubeQueryTimeDimensionsFormatted = !isComparisonView ? [{dimension:PlatformWiseKeyMapper[userPlatform]?.date,dateRange: [
    formatDate(calendarDate[0].startDate),
    formatDate(calendarDate[0].endDate),
  ]}] : [{dimension:PlatformWiseKeyMapper[userPlatform]?.date,compareDateRange:[
    [startDate, endDate],
    [startDatePrevious, endDatePrevious],
  ]}]

  const { clientAccountId } = useGlobalContext();
  const activeRequestRef = useRef(null);
  const latestRequestIdRef = useRef(0);
  const isProcessingUrlQueryRef = useRef(false);
  const processedUrlQueryRef = useRef(null);
  const isClearingSavedReportRef = useRef(false);
  const lastUrlViewTypeRef = useRef(viewTYPE);
  const [initialLoad, setInitialLoad] = useInitialLoad();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [filterModuleFilters, setFilterModuleFilters] = useState({});
  const [inclusionFilterModuleFilters, setInclusionFilterModuleFilters] = useState({});
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [showComplexFilter, setShowComplexFilter] = useState(false);
  const [isStoplossSaving, setIsStoplossSaving] = useState(false);
  const [isTabularView, setIsTabularView] = useState(true);
  const [quadrantAvgValues, setQuadrantAvgValues] = useState({avgSpend:0,avgROAS:0});

  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const [isPSLRuleFilterLoading, setIsPSLRuleFilterLoading] = useState(true);
const [showPercentage, setShowPercentage] = useState(false); // default false

  

  const [customAttributeMapping, setCustomAttributeMapping] = useState({});
  const groupByOptionsData = useMemo(() => {
    const baseOptions = GroupByOptionsDataConfig[userPlatform] || [];
    return baseOptions.map((option) => ({
      ...option,
      label: getMappedCustomAttributeLabel(
        option?.value,
        option?.label,
        customAttributeMapping
      ),
    }));
  }, [userPlatform, customAttributeMapping]);
  const initialGroupByFilter =
    allParams.get("reportType") ?? groupByOptionsData?.[0]?.value ?? "";
  const [groupByFilter,setGroupByFilter] = useState(initialGroupByFilter);
  const [extraDimensions, setExtraColumns] = useState([]);

  // Sync view type and report type from URL when query params change (e.g. sidebar link to ROAS view)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const viewtype = params.get("viewtype");
    const reportType = params.get("reportType");
    const nextUrlQuery = params.get("urlQuery");
    const analysisDimensionsParam = params.get("analysisDimensions");

    // Always sync URL-driven state, including the "no query" case.
    const nextViewType = viewtype ?? "PERFORMANCE";
    if (nextViewType !== lastUrlViewTypeRef.current) {
      lastUrlViewTypeRef.current = nextViewType;
      const pageConfig = getPageColumnCustomization(
        columnCustomizationConfig?.value,
        COLUMN_CUSTOMIZATION_PAGE_IDS.PRODUCT_ANALYTICS,
        allColumns
      );
      const initial = resolveInitialColumnState({
        columns: allColumns,
        viewType: nextViewType,
        pageConfig,
        standardOptions: VIEW_TYPE_OPTIONS,
      });
      setCurrentViewType(initial.viewType);
      setSelectedMetricKeys(initial.selectedColumnKeys);
      setColumnCollectionId(initial.collectionId);
    } else {
      setCurrentViewType(nextViewType);
    }

    const fallbackGroupBy = groupByOptionsData?.[0]?.value ?? "";
    const nextGroupBy =
      reportType && groupByOptionsData?.some((o) => o.value === reportType)
        ? reportType
        : fallbackGroupBy;
    setGroupByFilter(nextGroupBy);
    const nextGroupByDimensions =
      groupByOptionsData?.find((o) => o.value === nextGroupBy)?.dimensions || [];
    const allAllowedDimensions = [
      ...new Set([
        ...(groupByOptionsData || []).flatMap((option) => option?.dimensions || []),
        ...(isProductSetPage ? [PRODUCT_SET_SKU_DIMENSION] : []),
      ]),
    ];
    const parsedSavedDimensions = (analysisDimensionsParam || "")
      .split(",")
      .map((dimension) => dimension?.trim())
      .filter((dimension) => dimension && allAllowedDimensions.includes(dimension));
    const nextDimensions = ensureProductSetSkuDimension(
      parsedSavedDimensions.length > 0
        ? parsedSavedDimensions
        : nextGroupByDimensions,
      { isProductSetPage, userPlatform }
    );
    if (nextDimensions.length) {
      setCubeQueryDimensions(nextDimensions);
    }

    if (nextUrlQuery !== urlQuery) {
      setUrlQuery(nextUrlQuery);
    }

    // If URL no longer carries saved filters, clear persisted filter state.
    if (!nextUrlQuery) {
      if (urlQuery) {
        isClearingSavedReportRef.current = true;
      }
      processedUrlQueryRef.current = null;
      isProcessingUrlQueryRef.current = false;
      setFilterModuleFilters({});
      setIsFilterApplied(false);
    }
  }, [location.search, groupByOptionsData, urlQuery, isProductSetPage, userPlatform]);

  useEffect(() => {
    setIsLoaderVisible(true);
    processedUrlQueryRef.current = null;
    setCurrentPage(1);
  }, [location.search]);
  const [stoplossRuleDetail, setStoplossRuleDetail] = useState(stopLossConfigRule);
  const [productStopLossRuleList, setProductStopLossRuleList] = useState([]);
  const [customDate, setCustomDate] = useState("last_7d")
  const [inclusionCustomDate, setInclusionCustomDate] = useState("last_7d")
  const [stopLossFilterType, setStopLossFilterType] = useState("exclusion")
  const [errors, setErrors] = useState({});
  const [isCampaignsFetching, setIsCampaignsFetching] = useState(false);
  const [isProductSetFetching, setIsProductSetFetching] = useState(false);
  const [productDetailsShow, setProductDetailsShow] = useState(false); // Enum: "PERSONAL_DETAILS", "CREATED", "UPDATED"
  const [newRawData, setNewRawData] = useState([]);
  const [bulkScope, setBulkScope] = useState(BULK_SCOPE.SELECTED);
  const [bulkExcludeIds, setBulkExcludeIds] = useState([]);
  const [bulkConfirm, setBulkConfirm] = useState(null);
  const [pendingBulkOperation, setPendingBulkOperation] = useState(null);
  const [isBulkSubmitting, setIsBulkSubmitting] = useState(false);
  const [isBulkSuccess, setIsBulkSuccess] = useState(false);
  const [showPopulateAds, setShowPopulateAds] = useState(false);
  const [pendingPopulateOperation, setPendingPopulateOperation] = useState(null);
  const [tableRefreshNonce, setTableRefreshNonce] = useState(0);
  const lastInsightsQueryRef = useRef(null);
  const bulkScopeRef = useRef(BULK_SCOPE.SELECTED);
  const bulkExcludeIdsRef = useRef([]);
  const bulkIdKeysRef = useRef([]);
  const [newRawSummaryData, setNewRawSummaryData] = useState({});
  const [summaryDataWithoutFilter, setSummaryDataWithoutFilter] = useState({});
  const [totalProductCount, setTotalProductCount] = useState(0);
  const [inputValue, setInputValue] = useState("");  // immediate UI update
  const [searchValue, setSearchValue] = useState(""); // debounced search
  const [searchTrigger, setSearchTrigger] = useState(0);
   const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [downloadLimit, setDownloadLimit] = useState(5000);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isExportRedirectMode, setIsExportRedirectMode] = useState(false);


  // Only Product Set States ***** Start ******
  const initialConfigProductSetDetail = {
    name:'',
    is_dynamic:true,
    refresh_duration:'7 Days',
    product_set_type: PlatformWiseKeyMapper[userPlatform]?.productSetType,
    source:userPlatform,
    de_duplication:false
  }
  const [allProductSetList,setAllProductSetList] = useState([]);
  const [userDetails] = useUserDetails()
  const [productSetDetail,setProductSetDetail] = useState(initialConfigProductSetDetail);
  const [productSetCreationId, setProductSetCreationId] = useState("");
 
  const allProductSetName =   allProductSetList?.map((data) => {
    return data?.name
  }) ?? []
      

  const [cubeQueryMeasure, setCubeQueryMeasure] = useState(PlatformWiseQueryMeasures[userPlatform]);

  const initialCubeQueryDimensions = ensureProductSetSkuDimension(
    [
      ...(groupByOptionsData?.find((option) => option.value === groupByFilter)?.dimensions ||
        groupByOptionsData?.[0]?.dimensions ||
        []),
    ],
    { isProductSetPage, userPlatform }
  );

   const excludeSBCampaignsFiltering = {type: "RULE_ITEM","member":"VariantAnalysisTablePPMPlaceholder.campaignFormat","operator":"notEquals","values":["SB","SB(V)"]}

  const [cubeQueryOrder, setCubeQueryOrder] = useState(PlatformWiseQueryOrder[userPlatform]);

  const [cubeQueryDimensions, setCubeQueryDimensions] = useState(initialCubeQueryDimensions);
  const [allColumns, setAllColumns] = useState(
    getAllColumns(false, cubeQueryDimensions, customAttributeMapping) ?? []
  );

  const isAmazonProductAnalytics =
    userPlatform === "amazon" && !isStopLossPage && !isProductSetPage;
  const hasChildAsinDimension = isChildAsinInGroupBy(cubeQueryDimensions);
  const productAdGrain = getProductAnalyticsGrain(cubeQueryDimensions);
  const bulkIdKeys = useMemo(
    () => getProductAnalyticsBulkIdKeys(cubeQueryDimensions),
    [cubeQueryDimensions]
  );
  bulkScopeRef.current = bulkScope;
  bulkExcludeIdsRef.current = bulkExcludeIds;
  bulkIdKeysRef.current = bulkIdKeys;


  const [cubeQueryTimeDimensions, setCubeQueryTimeDimensions] = useState(cubeQueryTimeDimensionsFormatted);
  const [cubeChildExpendableRuleItems, setCubeChildExpendableRuleItems] = useState(
    // SAMPLE DATA FORMAT
    [
    //   {
    //     type: "RULE_ITEM",
    //     member: "VariantAnalysisTablePPMPlaceholder.parentSku",
    //     operator: "equals",
    //     values: ["BDISO284N2"],
    //   },
    ]
  );
  const [selectedMetricKeys, setSelectedMetricKeys] = useState(() => {
    if (VIEW_TYPE_OPTIONS.some((option) => option.value === viewTYPE)) {
      return getMetricKeysForView(allColumns, viewTYPE);
    }
    return getDefaultCustomSeedKeys(allColumns, null);
  });
  const [columnCollectionId, setColumnCollectionId] = useState(
    VIEW_TYPE_OPTIONS.some((option) => option.value === viewTYPE)
      ? viewTYPE
      : DEFAULT_CUSTOM_VIEW_ID
  );
  const [isColumnCustomizationSaving, setIsColumnCustomizationSaving] =
    useState(false);
  const hasHydratedColumnConfigRef = useRef(false);

  const pageColumnConfig = useMemo(
    () =>
      getPageColumnCustomization(
        columnCustomizationConfig?.value,
        COLUMN_CUSTOMIZATION_PAGE_IDS.PRODUCT_ANALYTICS,
        allColumns
      ),
    [columnCustomizationConfig, allColumns]
  );

  const metricColumns = useMemo(
    () =>
      getMetricColumns(allColumns).map((column) => ({
        ...column,
        label: column.shortTitle || column.title,
      })),
    [allColumns]
  );

  const columnCollections = useMemo(
    () => [
      ...buildStandardCollections(VIEW_TYPE_OPTIONS, allColumns),
      ...buildCustomCollections(pageColumnConfig, allColumns),
    ],
    [allColumns, pageColumnConfig]
  );

  const visibleTableColumns = useMemo(
    () => getVisibleColumns(allColumns, selectedMetricKeys),
    [allColumns, selectedMetricKeys]
  );

  useEffect(() => {
    if (!columnCustomizationConfig || !allColumns?.length) return;
    if (hasHydratedColumnConfigRef.current) return;

    const urlViewType =
      new URLSearchParams(location.search).get("viewtype") ?? currentViewType;
    if (urlViewType !== CUSTOM_VIEW_TYPE) {
      hasHydratedColumnConfigRef.current = true;
      return;
    }

    const initial = resolveInitialColumnState({
      columns: allColumns,
      viewType: CUSTOM_VIEW_TYPE,
      pageConfig: pageColumnConfig,
      standardOptions: VIEW_TYPE_OPTIONS,
    });
    setSelectedMetricKeys(initial.selectedColumnKeys);
    setColumnCollectionId(initial.collectionId);
    setCurrentViewType(CUSTOM_VIEW_TYPE);
    lastUrlViewTypeRef.current = CUSTOM_VIEW_TYPE;
    hasHydratedColumnConfigRef.current = true;
  }, [
    columnCustomizationConfig,
    allColumns,
    pageColumnConfig,
    currentViewType,
    location.search,
  ]);

  useEffect(() => {
    hasHydratedColumnConfigRef.current = false;
  }, [clientId, userPlatform]);

  useEffect(() => {
    const validKeys = new Set(
      getMetricColumns(allColumns).map((column) => column.key)
    );
    setSelectedMetricKeys((prev) => {
      const next = (prev || []).filter((key) => validKeys.has(key));
      if (next.length === prev.length) return prev;
      if (next.length) return next;
      if (currentViewType === CUSTOM_VIEW_TYPE) {
        return getDefaultCustomSeedKeys(allColumns, pageColumnConfig);
      }
      return getMetricKeysForView(allColumns, currentViewType);
    });
  }, [allColumns, currentViewType, pageColumnConfig]);

  const applyColumnSelectionLocally = ({
    collectionId,
    selectedColumnKeys,
  }) => {
    setSelectedMetricKeys(selectedColumnKeys);
    setColumnCollectionId(collectionId);
    const isStandard = VIEW_TYPE_OPTIONS.some(
      (option) => option.value === collectionId
    );
    if (isStandard) {
      lastUrlViewTypeRef.current = collectionId;
      setCurrentViewType(collectionId);
    } else {
      lastUrlViewTypeRef.current = CUSTOM_VIEW_TYPE;
      setCurrentViewType(CUSTOM_VIEW_TYPE);
    }
  };

  const handleApplyColumnCustomization = (payload) => {
    applyColumnSelectionLocally(payload);
  };

  const handleSaveColumnCustomization = async ({
    collectionId,
    selectedColumnKeys,
    collection,
  }) => {
    if (collection?.section !== "custom") return;
    setIsColumnCustomizationSaving(true);
    try {
      const view =
        pageColumnConfig.views.find((item) => item.id === collectionId) || {
          id: collectionId,
          name: collection?.label || "Custom View",
          isDefault: collectionId === DEFAULT_CUSTOM_VIEW_ID,
        };

      const nextConfig = await upsertCustomViewOnPage({
        clientId,
        platform: userPlatform,
        pageId: COLUMN_CUSTOMIZATION_PAGE_IDS.PRODUCT_ANALYTICS,
        view: {
          ...view,
          selectedColumnKeys,
        },
        activeViewId: collectionId,
        existingConfig: columnCustomizationConfig,
        columns: allColumns,
      });
      setColumnCustomizationConfig(nextConfig);
      applyColumnSelectionLocally({ collectionId, selectedColumnKeys });
      toast.success("Custom view saved");
    } catch (error) {
      toast.error(error?.message ?? "Unable to save custom view");
    } finally {
      setIsColumnCustomizationSaving(false);
    }
  };

  const handleSaveAsColumnCustomization = async ({
    name,
    selectedColumnKeys,
  }) => {
    setIsColumnCustomizationSaving(true);
    try {
      const newView = createNamedCustomView(name, selectedColumnKeys);
      const nextConfig = await upsertCustomViewOnPage({
        clientId,
        platform: userPlatform,
        pageId: COLUMN_CUSTOMIZATION_PAGE_IDS.PRODUCT_ANALYTICS,
        view: newView,
        activeViewId: newView.id,
        existingConfig: columnCustomizationConfig,
        columns: allColumns,
      });
      setColumnCustomizationConfig(nextConfig);
      applyColumnSelectionLocally({
        collectionId: newView.id,
        selectedColumnKeys,
      });
      toast.success("Custom view created");
    } catch (error) {
      toast.error(error?.message ?? "Unable to create custom view");
    } finally {
      setIsColumnCustomizationSaving(false);
    }
  };

  const handleRenameColumnView = async ({ collection, name }) => {
    if (!collection || collection.isDefault) return;
    setIsColumnCustomizationSaving(true);
    try {
      const nextConfig = await renameCustomViewOnPage({
        clientId,
        platform: userPlatform,
        pageId: COLUMN_CUSTOMIZATION_PAGE_IDS.PRODUCT_ANALYTICS,
        viewId: collection.id,
        name,
        existingConfig: columnCustomizationConfig,
        columns: allColumns,
      });
      setColumnCustomizationConfig(nextConfig);
      toast.success("View renamed");
    } catch (error) {
      toast.error(error?.message ?? "Unable to rename view");
    } finally {
      setIsColumnCustomizationSaving(false);
    }
  };

  const handleDeleteColumnView = async ({ collection }) => {
    if (!collection || collection.isDefault) return;
    setIsColumnCustomizationSaving(true);
    try {
      const wasActive =
        columnCollectionId === collection.id ||
        pageColumnConfig.activeViewId === collection.id;
      const nextConfig = await deleteCustomViewOnPage({
        clientId,
        platform: userPlatform,
        pageId: COLUMN_CUSTOMIZATION_PAGE_IDS.PRODUCT_ANALYTICS,
        viewId: collection.id,
        existingConfig: columnCustomizationConfig,
        columns: allColumns,
        fallbackActiveViewId: null,
      });
      setColumnCustomizationConfig(nextConfig);
      if (wasActive) {
        applyColumnSelectionLocally({
          collectionId: "PERFORMANCE",
          selectedColumnKeys: getMetricKeysForView(allColumns, "PERFORMANCE"),
        });
      }
      toast.success("View deleted");
    } catch (error) {
      toast.error(error?.message ?? "Unable to delete view");
    } finally {
      setIsColumnCustomizationSaving(false);
    }
  };

  const filterModalInCampaignListVisibilty = useSelector(
    (state) => state.campaignListData.filterModalInCampaignListVisibilty
  );

 // Only Product Set Functions *** Start ***

  function handleProductSetDetail (key,value) {
    setProductSetDetail((prev) => {
      const data = {...prev}
      if(key === 'name') {
        const isAlreadyExists =  checkDuplicateStringInArray(productSetDetail?.name,allProductSetName)
        if(isAlreadyExists) {
          data[key] = value;
          return data
        } else {
          data[key] = value
          setErrors({...errors,'name':''})
        }
      }
      data[key] = value
      return data
    })
  }

  const getSpends = (summaryData) => {
    let member = "VariantAnalysisTablePPMPlaceholder.cost";
    if (userPlatform === "amazon") {
      member = "VariantAnalysisTablePPMPlaceholder.cost";
    } else {
      member = "spends";
    }
    // handle normal and comparison view both data
    return summaryData[member] ?? summaryData?.current_data?.[member] ?? 0;
  };
  
  const getRoas = (summaryData) => {
    let member = "VariantAnalysisTablePPMPlaceholder.roas";
    if (userPlatform === "amazon") {
      member = "VariantAnalysisTablePPMPlaceholder.roas";
    } else {
      member = "roas";
    }
    return summaryData[member] ?? summaryData?.current_data?.[member] ?? 0;
  };
  const getOrders = (summaryData) => {
    let member = "VariantAnalysisTablePPMPlaceholder.conversions14d";
    if (userPlatform === "amazon") {
      member = "VariantAnalysisTablePPMPlaceholder.conversions14d";
    } else {
      member = "orders";
    }
    return summaryData[member] ?? summaryData?.current_data?.[member] ?? 0;
  };
  const calculateQuadrantAvgValues = (summaryData) => {
    const totalSpends = getSpends(summaryData);
    const totalOrders = getOrders(summaryData);
    const totalRoas = getRoas(summaryData);

    const avgSpends = totalOrders > 0 ? 1.5 * (totalSpends / totalOrders) : 0;
    const avgROAS = totalRoas > 0 ? totalRoas * 1.3 : 0;
    setQuadrantAvgValues({
      avgSpends: parseFloat(avgSpends?.toFixed(2)),
      avgROAS: parseFloat(avgROAS.toFixed(2)),
    });
  }

  const validateProductSetConfiguration = () => {
    const invalidProductSetName = productSetDetail?.name?.trim() == '' || productSetDetail?.name == undefined || productSetDetail?.name == null
    const isAlreadyExists =  checkDuplicateStringInArray(productSetDetail?.name,allProductSetName)
     if (invalidProductSetName) {
        setErrors((prev) => ({ ...prev, "name": "Please give valid Name." }));
        toast.error("Please enter product set name.");
        return false;
    } else if (!invalidProductSetName && isAlreadyExists && !productsetId) {
      setErrors((prev) => ({ ...prev, "name": "Product set Name already exists." }));
      toast.error("Product set name already exists. Please try a different one.");
      return false
    }
    return true
  }

  function formatDataForProductSet ()  {
    let formattedData = {};
    const exclusionQueryFilter = getUpdatedMappedFilter(filterModuleFilters,"exclusion");
    if (
      exclusionQueryFilter?.query?.dimensions?.length &&
      userPlatform === "amazon" &&
      !exclusionQueryFilter.query.dimensions.includes(PRODUCT_SET_SKU_DIMENSION)
    ) {
      exclusionQueryFilter.query.dimensions.push(PRODUCT_SET_SKU_DIMENSION);
    }
    const date_duration_refresh = `${productSetDetail?.refresh_duration?.match(
      /\d+/g
    )}_days`;
  
    if(!exclusionQueryFilter) {
      toast.error('Please apply filters before creating product set.')
      return false
    }
    formattedData = {
      name:productSetDetail?.name?.trim(),
      source: userPlatform,
      product_set_type:PlatformWiseKeyMapper[userPlatform]?.productSetType,
      is_dynamic:true,
      refresh_duration:date_duration_refresh,
      cube_filters:JSON.stringify(exclusionQueryFilter),
      de_duplication:productSetDetail?.de_duplication ?? false,
      modified_by:userDetails?.user?.email,
    }
    return formattedData
  }

  async  function handleSaveProductSet () {
    const isValid = validateProductSetConfiguration();
    if (!isValid) {
      return;
    }
    const formattedData = formatDataForProductSet();
    if(typeof formattedData === 'boolean') {
      return;
    }
    try {
      let data = {};
      if(totalProductCount === 0){
        toast.error("A Smart Product Set must contain at least one product.")
        return;
      }
      const url = productsetId ? `${process.env.REACT_APP_ADS_API}/client/${clientId}/product-set/${productsetId}?source=${userPlatform}` : `${process.env.REACT_APP_ADS_API}/client/${clientId}/product-set?source=${userPlatform}`;
      setIsStoplossSaving(true);
      setInitialLoad(true)
      if(productsetId) {
        data = await axios.patch(url,formattedData,{headers:{
          'Content-Type':'application/merge-patch+json'
        }})
      } else {
        data = await axios.post(url,formattedData)
      }
      if (data.status === 200 && !productsetId) {
        toast.success("Product set created successfully!")
        setProductSetCreationId(data?.data?.id);
        setProductDetailsShow("CREATED");
      } else if (data.data?.success && productsetId) {
        toast.success("Product set updated successfully!")
        setProductDetailsShow("UPDATED");

      } else {
          toast.error("Error while saving product set. Try Again!")
      }
      setIsStoplossSaving(false);
      setInitialLoad(false)
    } catch (error) {
      setIsStoplossSaving(false);
      setInitialLoad(false)
      const message = error?.response?.status!==200 ? error?.response?.data?.message : error?.message
      toast.error(message ?? 'Some unknown error occurred!')
    }
  }

  async function fetchProductSetList() {
    try {
      setIsProductSetFetching(true)
      const urlForAllProductSets = `${process.env.REACT_APP_ADS_API}/client/${clientId}/product-set?source=${userPlatform}&categories`
      const allProductSets = await axios.get(urlForAllProductSets)
      const productSetData = allProductSets?.data ?? []
      setAllProductSetList(productSetData ?? []);
      if(productSetData?.length && productsetId) {
        const foundedProductSet = productSetData?.find((productSet) => {
          return productSet?.id?.toLowerCase() === productsetId
        }) ?? {}
        foundedProductSet['refresh_duration'] = PRODUCT_SET_REFRESH_DURATION[foundedProductSet['refresh_duration']] ?? '7 Days'
        setProductSetDetail(foundedProductSet ?? {});
        let apiFilter = {};
        const parsedQuery = JSON.parse(foundedProductSet?.cube_filters ?? '{}')
        setCustomDate(parsedQuery?.query?.date_preset);
        let filterCustomFormatExclusion = reverseMergeAPIFiltersToFilterModuleFormat(parsedQuery?.query?.filters);
         let updatedDimension = removeRuleItemByMember(filterCustomFormatExclusion?.dimension,"VariantAnalysisTablePPMPlaceholder.profileId");
         let updatedAmazonCampaign = removeRuleItemByMember(filterCustomFormatExclusion?.campaigns,"VariantAnalysisTablePPMPlaceholder.campaignFormat");
         filterCustomFormatExclusion.dimension = updatedDimension;
          filterCustomFormatExclusion.campaigns = updatedAmazonCampaign;
          apiFilter = filterCustomFormatExclusion;
         setFilterModuleFilters(filterCustomFormatExclusion);
         handleDataFetch(apiFilter, parsedQuery?.query?.date_preset)
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message ?? 'some unknown error occurred while fetching product set')
    } finally{
      setIsProductSetFetching(false)
    }
  }

 

    useEffect(() => {
      if(isProductSetPage) {
        fetchProductSetList();
        setIsPSLRuleFilterLoading(false);
      }
    },[])


  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("start") && queryParams.get("end")) {
      setDate(queryParams.get("start"), queryParams.get("end"));
    }
  }, []);

  const setDate = (currentDate, previousDate) => {
    const dates = {
      startDate: new Date(currentDate),
      endDate: new Date(previousDate),
      key: "selection",
    };
    setDateDifference("Custom");
    setCalendarDate([dates]);
    setCubeQueryTimeDimensions((prev) => {
      let data = [...prev];
      data[0]["dateRange"] = [
        formatDate(dates.startDate),
        formatDate(dates.endDate),
      ];
      return data;
    });
  };

  const getStopLossEntityStatusRuleItem = (filterType) => {
    if (userPlatform === "amazon") {
      return {
        type: "RULE_ITEM",
        member: "VariantAnalysisTablePPMPlaceholder.stop_loss_entity_status",
        operator: "equals",
        values: [filterType === "exclusion" ? "ACTIVE" : "PAUSED"],
      };
    }
    if (userPlatform === "myntra") {
      return {
        type: "RULE_ITEM",
        member: "stop_loss_entity_status",
        operator: "equals",
        values: [filterType === "exclusion" ? "ACTIVE" : "PAUSED"],
      };
    }
    return null;
  };

  const getStopLossFiltersByType = (filterType = stopLossFilterType) =>
    filterType === "exclusion"
      ? filterModuleFilters
      : inclusionFilterModuleFilters;

  const handleFilterOutput = (filters, type) => {
    setCurrentPage(1);
    setShowComplexFilter(false)
    if(filters?.dimension?.data?.length === 0 && filters?.metrics?.data?.length === 0 && filters?.campaigns?.data?.length === 0 && filters?.topX?.data?.length === 0 && filters?.comparisonPercentage?.data?.length === 0) {
      setIsFilterApplied(false);
    }else{
      setIsFilterApplied(true);
    }
    setFilterModuleFilters(filters);
  };

  const handleInclusionFilterOutput = (filters, type) => {
    setCurrentPage(1);
    setInclusionFilterModuleFilters(filters);
  };

  const handleStopLossFilterTypeChange = (filterType) => {
    if (!filterType || filterType === stopLossFilterType) {
      return;
    }
    setStopLossFilterType(filterType);
    setCurrentPage(1);
    const filters = getStopLossFiltersByType(filterType);
    const datePreset =
      filterType === "exclusion" ? customDate : inclusionCustomDate;
    handleDataFetch(filters, datePreset, filterType);
  };


  // useEffect(() => {
  //   if (!isComparisonView) {
      
  // }, [applyCalendar]);

  useEffect(() => {
    if (isComparisonView) {
      let startDate = formatDate(multiCalendarDate.selection1.startDate);
      let endDate = formatDate(multiCalendarDate.selection1.endDate);
      let startDatePrevious = formatDate(
        multiCalendarDate.selection2.startDate
      );
      let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
      let apiDateRange = cubeQueryTimeDimensions[0]["compareDateRange"];
      if (
        startDate !== apiDateRange[0][0] ||
        endDate !== apiDateRange[0][1] ||
        startDatePrevious !== apiDateRange[1][0] ||
        endDatePrevious !== apiDateRange[1][1]
      ) {
        setIsLoaderVisible(true);
        setCubeQueryTimeDimensions((prev) => {
          let data = [...prev];
          data[0]["compareDateRange"] = [
            [startDate, endDate],
            [startDatePrevious, endDatePrevious],
          ];
          return data;
        });
      }
      window.sessionStorage.setItem("dateDiff", dateDifference);
      setDateDifference("Custom");
    } else if (!isComparisonView) {
      const startDate = formatDate(calendarDate[0].startDate);
      const endDate = formatDate(calendarDate[0].endDate);
      if (
        startDate !== cubeQueryTimeDimensions[0]["dateRange"][0] ||
        endDate !== cubeQueryTimeDimensions[0]["dateRange"][1]
      ) {
        setIsLoaderVisible(true);
        setCubeQueryTimeDimensions((prev) => {
          let data = [...prev];
          data[0]["dateRange"] = [startDate, endDate];
          return data;
        });
      }
    }
  }, [applyCalendar]);


 async function getProductReportData(filter, comparisonApi, fetchedCustomDate = null) {
  const requestId = latestRequestIdRef.current + 1;
  latestRequestIdRef.current = requestId;
  if (activeRequestRef.current) {
    activeRequestRef.current.abort();
  }
  const controller = new AbortController();
  activeRequestRef.current = controller;

  try {
    setIsLoaderVisible(true);

    let url = "";
    let SummaryUrl = "";

    if (comparisonApi) {
      url = `${process.env.REACT_APP_CATALOG_API}/client/${clientId}/products:comparison?source=${userPlatform}`;
      SummaryUrl = `${process.env.REACT_APP_CATALOG_API}/client/${clientId}/products:comparison-summary?source=${userPlatform}`;
    } else {
      url = `${process.env.REACT_APP_CATALOG_API}/client/${clientId}/products:insights?source=${userPlatform}`;
      SummaryUrl = `${process.env.REACT_APP_CATALOG_API}/client/${clientId}/products:insights-summary?source=${userPlatform}`;
    }

    const queryData = {
      // remove product_name from queryDimensions
      dimensions: cubeQueryDimensions.filter((dimension) => dimension !== "product_name"),
      filters: filter,
      extra_filters: {
        type: `${userPlatform}`,
        [PlatformWiseKeyMapper[userPlatform]?.defaultCampaignBackend]: filter?.campaigns,
      },
      percentile_filters: transformToTopXArray(filter?.topX) ?? [],
      ...(comparisonApi
        ? (() => {
            const comparisonPercentageFilters =
              getComparisonPercentageFiltersRuleTree(filter?.comparisonPercentage);
            return comparisonPercentageFilters
              ? { comparison_percentage_filters: comparisonPercentageFilters }
              : {};
          })()
        : {}),
      measures: [...cubeQueryMeasure,  ...cubeQueryDimensions],
      order: cubeQueryOrder,
      date_preset: fetchedCustomDate ?? (isPageUnderDynamicSection ? customDate : null),
      timeDimensions: comparisonApi
        ? getComparisonFormatTimeDimension(cubeQueryTimeDimensions)
        : cubeQueryTimeDimensions,
      offset: (currentPage - 1) * itemsPerPage,
      limit: itemsPerPage,
    };

    const dataToPost = { query: queryData };
    lastInsightsQueryRef.current = queryData;

    // Prepare query for summary without filters
    let filterForSummaryWithoutFilters = {};
    let tempFilter = JSON.parse(JSON.stringify(filterForSummaryWithoutFilters));
    if(userPlatform === 'amazon'){
      tempFilter = ruleItemInjector(tempFilter,"dimensions", defaultDimensions(clientAccountId));
      tempFilter = ruleItemInjector(tempFilter,"campaigns", defaultDimensions("",[excludeSBCampaignsFiltering]));
    }
    const summaryWithoutFiltersDataToPost = {
      query: {
        ...queryData,
        filters: tempFilter, // empty filter for total summary without filter
        percentile_filters: [],
      },
    };
    delete summaryWithoutFiltersDataToPost.query.comparison_percentage_filters;

    // Fetch all APIs in parallel
    const [summaryData, summaryDataWithoutFilters, data] = await Promise.all([
      // Summary with filters
      axios.post(SummaryUrl, dataToPost, { signal: controller.signal }),
      // Summary without filters
      axios.post(SummaryUrl, summaryWithoutFiltersDataToPost, {
        signal: controller.signal,
      }),
      // Main data
      axios.post(url, dataToPost, { signal: controller.signal }),
    ]);

    if (requestId !== latestRequestIdRef.current) {
      return;
    }

    // Process summary without filters
    if (summaryDataWithoutFilters?.status === 200) {
      setSummaryDataWithoutFilter(summaryDataWithoutFilters?.data ?? {});
    }

    // Process summary with filters
    let totalCount = 0;
    if (summaryData?.status === 200) {
      totalCount = summaryData?.data?.total_count ?? 0;
      setTotalProductCount(totalCount);
    }

    // Process main data
    if (data?.status === 200) {
      const rows = data?.data?.data ?? [];
      setNewRawData(
        syncRowsWithBulkScope({
          rows,
          scope: bulkScopeRef.current,
          excludeIds: bulkExcludeIdsRef.current,
          idKeys: bulkIdKeysRef.current,
        })
      );
      setNewRawSummaryData(summaryData?.data ?? {});
      setTotalPages(Math.ceil(totalCount / itemsPerPage) ?? 1);

      calculateQuadrantAvgValues(summaryData?.data);
     
    }
  } catch (error) {
    if (
      error?.code === "ERR_CANCELED" ||
      error?.name === "CanceledError" ||
      axios.isCancel?.(error)
    ) {
      return;
    }
    console.error(error); // keep normal error logging
    toast.error(
      error?.response?.data?.message ??
        error?.message ??
        "Some unknown error occurred!"
    );
  } finally {
    if (requestId === latestRequestIdRef.current) {
      setIsLoaderVisible(false);
    }
    if (activeRequestRef.current === controller) {
      activeRequestRef.current = null;
    }
  }
}

 const handleOpenPopover = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleCloseDownloadPopover = () => {
    setDownloadAnchorEl(null);
  };

  const downloadPopoverOpen = Boolean(downloadAnchorEl);

  // const handleApply = async () => {
  //   handleCloseDownloadPopover();
  //   await handleDownloadAllProductData(
  //     filterModuleFilters,
  //     currentViewType === "Comparison View",
  //     null,
  //     downloadLimit
  //   );
  // };

const handleDownloadButtonClick = async () => {
  if (isExportRedirectMode) {
    openRequestTrackingPage();
    return;
  }

  if ((totalProductCount ?? 0) <= 0) {
    toast.info("No records available for export.");
    return;
  }

  await handleDownloadAllProductData(
    filterModuleFilters,
    isComparisonView,
    null,
    downloadLimit,
    setIsDownloading,
    userPlatform,
    clientId,
    clientAccountId,
    cubeQueryDimensions.filter((dimension) => dimension !== "product_name"),
    [...cubeQueryMeasure, ...cubeQueryDimensions],
    cubeQueryOrder,
    cubeQueryTimeDimensions,
    isPageUnderDynamicSection,
    customDate,
    excludeSBCampaignsFiltering,
    PlatformWiseKeyMapper,
    transformToTopXArray,
    getComparisonPercentageFiltersRuleTree,
    getComparisonFormatTimeDimension,
    allColumns,
    currentViewType,
    {},
            {
              enableBackendExport: true,
              triggeredBy:
                userDetails?.user?.email ?? localStorage.getItem("email") ?? "",
              onBackendExportSuccess: () => setIsExportRedirectMode(true),
              visibleColumnKeys: visibleTableColumns.map((column) => column.key),
            }
  );
};

  useEffect(() => {
    setIsExportRedirectMode(false);
  }, [
    filterModuleFilters,
    applyCalendar,
    isComparisonView,
    currentViewType,
    searchValue,
    cubeQueryDimensions,
    cubeQueryMeasure,
    cubeQueryOrder,
    cubeQueryTimeDimensions,
  ]);

  const getSelectedSearchDimensions = () => {
    const selectedColumnKeys = allColumns
      .filter((column) => column?.isDimension && column.key !== "date")
      .map((column) => column.key);

    const expandedDimensions = selectedColumnKeys.flatMap((key) => {
      const groupOption = groupByOptionsData?.find((option) =>
        option?.dimensions?.includes(key)
      );
      return groupOption?.dimensions || [key];
    });

    return [...new Set(expandedDimensions)].filter(
      (dimension) =>
        dimension !== "date" && cubeQueryDimensions.includes(dimension)
    );
  };

  const selectedSearchDimensions = useMemo(
    () => getSelectedSearchDimensions(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allColumns, cubeQueryDimensions, groupByOptionsData]
  );

  const applySearchOnFilters = (baseFilter = {}) => {
    const searchText = searchValue?.trim();
    if (!searchText) return baseFilter;

    const searchRuleItems = selectedSearchDimensions.map((dimension) => ({
      type: "RULE_ITEM",
      member: dimension,
      operator: "contains",
      values: [searchText],
    }));

    if (!searchRuleItems.length) return baseFilter;

    return ruleItemInjector(
      baseFilter,
      "dimensions",
      defaultDimensions("", searchRuleItems),
      "OR_RULE"
    );
  };

  const handleDataFetch = (
    moduleFilters,
    fetchedCustomDate = null,
    filterType = "exclusion"
  ) => {
    const filters = mergeCustomOutputToAPIFiltersFormatWithComparisonPercentage(
      moduleFilters?.metrics?.custom_output,
      moduleFilters?.dimension?.custom_output,
      moduleFilters?.campaigns?.custom_output,
      moduleFilters?.topX?.custom_output,
      isComparisonView
        ? moduleFilters?.comparisonPercentage?.custom_output
        : null
    );
    
    let tempFilter = JSON.parse(JSON.stringify(filters));
       if(userPlatform === 'amazon'){
        tempFilter = ruleItemInjector(tempFilter,"dimensions", defaultDimensions(clientAccountId));
        tempFilter = ruleItemInjector(tempFilter,"campaigns", defaultDimensions("",[excludeSBCampaignsFiltering]));
       }
    if (isStopLossPage) {
      const stopLossStatusRuleItem = getStopLossEntityStatusRuleItem(filterType);
      if (stopLossStatusRuleItem) {
        tempFilter = ruleItemInjector(tempFilter, "dimensions", [
          stopLossStatusRuleItem,
        ]);
      }
    }
    tempFilter = applySearchOnFilters(tempFilter);
    setIsLoaderVisible(true);
    const effectiveCustomDate =
      fetchedCustomDate ??
      (isPageUnderDynamicSection
        ? filterType === "exclusion"
          ? customDate
          : inclusionCustomDate
        : null);
    getProductReportData(tempFilter, isComparisonView, effectiveCustomDate);
  };

  useEffect(() => {
    // Skip if we're currently processing urlQuery to avoid duplicate API calls
    if (isProcessingUrlQueryRef.current) {
      return;
    }
    
    if (urlQuery && processedUrlQueryRef.current !== urlQuery) {
      processedUrlQueryRef.current = urlQuery;
      handleQueryChange(urlQuery);
      return;
    }

    const effectiveFilters = isClearingSavedReportRef.current
      ? {}
      : isStopLossPage
        ? getStopLossFiltersByType()
        : filterModuleFilters;
    isClearingSavedReportRef.current = false;

    if(pageType === "stoploss" || isProductSetPage){
      if((pslRuleId || productsetId) && isPSLRuleFilterLoading){
        return;
      }else{
        handleDataFetch(
          effectiveFilters,
          null,
          isStopLossPage ? stopLossFilterType : "exclusion"
        );
      }
    } else {
      handleDataFetch(effectiveFilters)
    }

  }, [
    cubeQueryMeasure,
    cubeQueryDimensions,
    cubeQueryTimeDimensions,
    cubeToken,
    cubeQueryOrder,
    location.search,
    urlQuery
  ]);

  useEffect(() => {
    // refetch columns on dimension change
    let updatedColumns = getAllColumns(
      false,
      cubeQueryDimensions,
      customAttributeMapping
    );
    setAllColumns(() => [...updatedColumns]);
  }, [cubeQueryDimensions, customAttributeMapping]);

  // const expendChange = (data, type, index) => {
  //   if(groupByFilter === "Product") {
  //     if (type === "campaign_format_child" || type === "link") {
  //       let url = "/master-ads?asinId=" + data;
  //       window.open(url);
  //     } else {
  //       if(groupByFilter === "Product") {

  //         setCubeChildExpendableRuleItems(
  //           [
  //             {
  //               type: "RULE_ITEM",
  //               member: "VariantAnalysisTablePPMPlaceholder.parentSku",
  //               operator: "equals",
  //               values: [data],
  //             },
  //           ]
  //         )
  //       } 
  //       // setCubeChildRowsQueryFilters(prevData);
  //       setChildDataIndex(data);
  //     }
  //   } else if (groupByFilter?.includes("Broad")) {
  //     setChildDataIndex(data);
  //     setCubeChildExpendableRuleItems(
  //       [
  //         {
  //           type: "RULE_ITEM",
  //           member: "VariantAnalysisTablePPMPlaceholder.broadCategory",
  //           operator: "equals",
  //           values: [data],
  //         },
  //       ]
  //     )
      
  //   } else if(groupByFilter?.includes("Detailed")) {
  //     let url = "/product-analytics";
  //     const filters = mergeCustomOutputToAPIFiltersFormat(
  //       filterModuleFilters?.metrics?.custom_output,
  //       filterModuleFilters?.dimension?.custom_output,
  //       filterModuleFilters?.campaigns?.custom_output,
  //       filterModuleFilters?.topX?.custom_output,
  //     );
  //     let categoryRule =[

  //           {
  //             type: "RULE_ITEM",
  //             member: "VariantAnalysisTablePPMPlaceholder.category",
  //             operator: "equals",
  //             values: [data],
  //           },
  //   ]
  //   let updatedFiltersWithDimensions = ruleItemInjector(filters,"dimensions", defaultDimensions("",categoryRule));

  //   const queryParams = [
  //     ["start", formatDate(calendarDate[0].startDate)],
  //     ["end", formatDate(calendarDate[0].endDate)],
  //     ["viewtype",currentViewType]
  //   ];
  //   const queryString = queryParams
  //     .filter(([key, value]) => value !== "All")
  //     .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
  //     .join("&");
  //   url += `?${queryString}&urlQuery=${encodeURIComponent(JSON.stringify(updatedFiltersWithDimensions))}`;
  //   // Open URL in new tab

  //   window.open(url);
  //   }
  // };

  useEffect(() => {
    // Prevent search/pagination-triggered fetch from overriding urlQuery fetch.
    if (
      isProcessingUrlQueryRef.current ||
      (urlQuery && processedUrlQueryRef.current !== urlQuery)
    ) {
      return;
    }
    const effectiveFilters = isClearingSavedReportRef.current
      ? {}
      : isStopLossPage
        ? getStopLossFiltersByType()
        : filterModuleFilters;
    isClearingSavedReportRef.current = false;
    handleDataFetch(
      effectiveFilters,
      null,
      isStopLossPage ? stopLossFilterType : "exclusion"
    );
  }, [
    searchValue,
    searchTrigger,
    currentPage,
    itemsPerPage,
    filterModuleFilters,
    inclusionFilterModuleFilters,
    tableRefreshNonce,
  ]);

  useEffect(() => {
    return () => {
      if (activeRequestRef.current) {
        activeRequestRef.current.abort();
      }
    };
  }, []);

  const validateAlphanumeric = (input) => {
    const alphanumericRegex = /^[a-zA-Z0-9_\s]*$/;// /^[a-zA-Z0-9_\/\s]*$/;
    return alphanumericRegex.test(input);
  }
  const handleCustomDate = (option) => {
    setCustomDate(option.value)
    if (isStopLossPage && stopLossFilterType === "exclusion") {
      handleDataFetch(filterModuleFilters, option.value, "exclusion");
    }
  }

const handleInclusionCustomDate = (option) => {
    setInclusionCustomDate(option.value)
    if (isStopLossPage && stopLossFilterType === "inclusion") {
      handleDataFetch(inclusionFilterModuleFilters, option.value, "inclusion");
    }
}

  const handleStoplossRuleDetail = (key, value, include = true) => {
    setStoplossRuleDetail((prev) => {
        let data = { ...prev }
        if (key == 'frequency') {
            if (value == 'Weekly') {
                data['stoploss_running_days'] = ['monday'];
            } else if (value == 'Biweekly') {
                data['stoploss_running_days'] = ['monday', 'thursday'];
            }else if(value=='Daily'){
                // Copy to avoid mutating shared constant array downstream.
                data['stoploss_running_days'] = [...ALL_WEEK_DAYS];
            }
            data[key] = value;
            return data;

        }
        else if (key == 'stoploss_running_days') {
            // Copy to avoid in-place mutation of existing React state / constants.
            let stopLossDays = Array.isArray(data['stoploss_running_days'])
              ? [...data['stoploss_running_days']]
              : [];
            const index = stopLossDays.indexOf(value);

            if (index !== -1) {
                stopLossDays.splice(index, 1);
            } else {
                if (data['frequency'] == 'Biweekly' && stopLossDays.length >= 2) {
                    stopLossDays[1] = value;
                } else if (data['frequency'] == 'Weekly') {
                    stopLossDays[0] = value;
                } else {
                    stopLossDays.push(value);
                }
            }

            data['stoploss_running_days'] = stopLossDays;
            return data;
            

        } else if (key === 'name') {
            const nameExistAlready = productStopLossRuleList.includes(value?.trim());
            
            if (!validateAlphanumeric(value) || value.startsWith(' ')) {
                setErrors((prev) => ({ ...prev, "name": "Only alphabet, number and underscore are allowed." }));
                return data;
            } else if (nameExistAlready && !pslRuleId) {
                setErrors((prev) => ({ ...prev, "name": "Rule Name Already Exists!" }));
                data[key] = value;
                return data;
            } else {
                setErrors((prev) => ({ ...prev, "name": '' }));
                data[key] = value;
                return data;
            }
        } else if (key=='max_percent_exclude'){
                setErrors((prev) => ({ ...prev, "max_percent_exclude": '' }));
                data[key] = value;
                return data;
        }
        else {
            data[key] = value;
            return data;
        }
    })
}

const validateStoplossRuleConfiguration = () => {
  for (const key in errors) {
      if (errors[key]) {
          toast.error("Please resolve all the errors." );       
          return false; // Found a truthy value, return false
      }
    }     
   if (stoplossRuleDetail.name?.trim() == '' || stoplossRuleDetail.name == undefined || stoplossRuleDetail.name == null) {
      setErrors((prev) => ({ ...prev, "name": "Please give valid Rule Name." }));
      toast.error("Enter valid Rule Name.");
      return false;
  } else if (
    stopLossFilterType === "exclusion" &&
    isNaN(stoplossRuleDetail.max_percent_exclude)
  ) {
      toast.error("Please select Exclusion limit between 10 and 100.");
      setErrors((prev) => ({ ...prev, "max_percent_exclude": " " }));
      return false;

  }else {
      return true
  }
}

const getUpdatedMappedFilter = (filterModule,filterType="") => {
  const filters = mergeCustomOutputToAPIFiltersFormatWithComparisonPercentage(
    filterModule?.metrics?.custom_output,
    filterModule?.dimension?.custom_output,
    filterModule?.campaigns?.custom_output,
    filterModule?.topX?.custom_output,
    isComparisonView
      ? filterModule?.comparisonPercentage?.custom_output
      : null
  );
  let tempFilter = JSON.parse(JSON.stringify(filters));
  // exclusion Validation
  if(!Object.keys(tempFilter)?.length>0){
    return false;
  }

 if(userPlatform === 'amazon'){
  tempFilter = ruleItemInjector(tempFilter,"dimensions", defaultDimensions(clientAccountId,cubeChildExpendableRuleItems));
  tempFilter = ruleItemInjector(tempFilter,"campaigns", defaultDimensions("",[excludeSBCampaignsFiltering]));
 }
  let tempExtraFilters = tempFilter?.campaigns;
  let percentileFilters = transformToTopXArray(tempFilter?.topX) ?? [];
  const comparisonPercentageFilters = isComparisonView
    ? getComparisonPercentageFiltersRuleTree(tempFilter?.comparisonPercentage)
    : null;
      let extraFilters = {
        type:`${userPlatform}`,
        [PlatformWiseKeyMapper[userPlatform]?.defaultCampaignBackend]: tempExtraFilters,
      };
      const queryData = {
        dimensions: cubeQueryDimensions.filter((dimension) => dimension !== "product_name"),
        filters: tempFilter,
        extra_filters: extraFilters,
        percentile_filters: percentileFilters,
        ...(isComparisonView && comparisonPercentageFilters
          ? { comparison_percentage_filters: comparisonPercentageFilters }
          : {}),
        measures: [...cubeQueryMeasure, ...cubeQueryDimensions],
        order: cubeQueryOrder,
        date_preset: isPageUnderDynamicSection ? filterType === "exclusion" ? customDate : inclusionCustomDate : null,
        timeDimensions:cubeQueryTimeDimensions,
        limit:1000,
      };
      const dataToPost = {
        query: queryData,
      };
      return dataToPost;
}

const formatStoplossRuleConfiguration = () => {
  let formattedData ={};
  
  const isExclusionFilter = stopLossFilterType === "exclusion";
  var exclusionQueryFilter = isExclusionFilter
    ? getUpdatedMappedFilter(filterModuleFilters, "exclusion")
    : null;
  var inclusionQueryFilter = !isExclusionFilter
    ? getUpdatedMappedFilter(inclusionFilterModuleFilters, "inclusion")
    : null;
  if (!(exclusionQueryFilter || inclusionQueryFilter)) {
    toast.error(
      `Please apply ${isExclusionFilter ? "exclusion" : "inclusion"} filters to create Stop-loss Rule.`
    );
    return false;
  }
const exclusionTimePeriod = customDateToTimePeriod(customDate, "");
const inclusionTimePeriod = customDateToTimePeriod(inclusionCustomDate, "");


  let ruleTasks =[];
  if(exclusionQueryFilter) {
      ruleTasks.push({
        "entity_metric_filter":
        {
            "timePeriod": exclusionTimePeriod || "",
            "type": "CUBE_BASED_NESTED_AND_OR", 
            "filters": [],
            "cube_filters": JSON.stringify(exclusionQueryFilter)
        }, 
        "rule_action_config":
         { 
            "entity_action_config": { "action_type": "PAUSE_PRODUCTS" }, 
            "max_percent_exclude": stoplossRuleDetail.max_percent_exclude 
        }
    });
  }
  if(inclusionQueryFilter) {
      ruleTasks.push({
          "entity_metric_filter":
          {
              "timePeriod": inclusionTimePeriod || "",
              "type": "CUBE_BASED_NESTED_AND_OR", 
              "filters": [],
              "cube_filters": JSON.stringify(inclusionQueryFilter)
          }, 
          "rule_action_config":
           { 
              "entity_action_config": { "action_type": "ENABLE_PRODUCTS"}, 
          }
      })
  }
      var ruleScheduleConfig = {
      'day_frequency': stoplossRuleDetail?.frequency,
        'frequency_values': stoplossRuleDetail?.stoploss_running_days
        }

  formattedData ={
      client_id : clientId,
      type:STOP_LOSS_RULE_TYPE[`${userPlatform.toLowerCase()}`],
      name: stoplossRuleDetail?.name?.trim(),
      modified_by: localStorage.getItem('email'),
      status:'Active',
      rule_objective:"Stop Loss",
      apply_decision : !stoplossRuleDetail?.recommend_only,
      rule_tasks: ruleTasks,
      schedule_config: ruleScheduleConfig,
      source: userPlatform
  }

  return formattedData
}

async function handleSaveStoplossRuleFunction() {
  const isValid = validateStoplossRuleConfiguration();
  if (!isValid) {
      return;
  }
  let formattedData = formatStoplossRuleConfiguration();
  if(typeof formattedData === 'boolean'){
    return;
  }
      let data = {};
      setIsStoplossSaving(true);
      try {
        if(pslRuleId){
          data = await axios.patch(`${process.env.REACT_APP_ADS_API}/client/${clientId}/automation-rule-set/${pslRuleId}?source=${userPlatform}&type=${STOP_LOSS_RULE_TYPE[`${userPlatform.toLowerCase()}`]}`, formattedData);
       }else{
          data = await axios.post(`${process.env.REACT_APP_ADS_API}/client/${clientId}/automation-rule-set?source=${userPlatform}&type=${STOP_LOSS_RULE_TYPE[`${userPlatform.toLowerCase()}`]}`, formattedData);
       }
       if (data.data?.id && !pslRuleId) {
          toast.success("Stoploss Rule created successfully!")
           navigate('/stop-loss-list');
       } else if (data.data?.success && pslRuleId) {
          toast.success("Stoploss Rule updated successfully!")
           navigate('/stop-loss-list');
     } else {
          toast.error("Error while saving Stoploss Rule. Try Again!")
     }
      } catch (error) {
        const message = error?.response?.status!==200 ? error?.response?.data?.message : error?.message
        toast.error(message ?? 'Some unknown error occurred!')
      }
    
    setIsStoplossSaving(false);
  }


  // async function getChildProductReportData(filter,comparisonApi) {
  //   try {
  //     let url = "";
  //     if(comparisonApi){
  //       url = `${process.env.REACT_APP_CATALOG_API}/client/${clientId}/products:comparison?source=${userPlatform}`;
  //     }else{
  //        url = `${process.env.REACT_APP_CATALOG_API}/client/${clientId}/products:insights?source=${userPlatform}`;
  //       }
  //     let tempExtraFilters = filter?.campaigns;
  //     let percentileFilters = transformToTopXArray(filter?.topX) ?? [];
      
  //     let extraFilters = {
  //       type: `${userPlatform}`,
  //       [PlatformWiseKeyMapper[userPlatform]?.defaultCampaignBackend]: tempExtraFilters,
  //     };

  //     const queryData = {
  //       dimensions: cubeChildRowsQueryDimensions,
  //       filters: filter,
  //       extra_filters: extraFilters,
  //       percentile_filters: percentileFilters,
  //       measures: cubeQueryMeasure,
  //       order: cubeChildRowQueryOrder,
  //       timeDimensions: comparisonApi?getComparisonFormatTimeDimension(cubeQueryTimeDimensions):cubeQueryTimeDimensions,
  //       limit:10000,
  //     };
  //     const dataToPost = {
  //       query: queryData,
  //     };
  //     const data = await axios.post(url, dataToPost);
  //     if (data?.status === 200) {
  //       let parsedCubeFormatData = {};
  //       if(comparisonApi){
  //         parsedCubeFormatData = createComparisonCubeLoadResponse({measures:cubeQueryMeasure,dimensions:cubeChildRowsQueryDimensions,order:cubeChildRowQueryOrder,filters:filter, data:data?.data?.data,timeDimensions:getComparisonFormatTimeDimension(cubeQueryTimeDimensions)});
  //       }else{
  //         parsedCubeFormatData = createCubeLoadResponse({measures:cubeQueryMeasure,dimensions:cubeChildRowsQueryDimensions,order:cubeChildRowQueryOrder,filters:filter, data:data?.data?.data,timeDimensions:cubeQueryTimeDimensions});
  //       }
  //       return parsedCubeFormatData;
  //     }
  //   } catch (error) {
  //     toast.error("unknown error occurred" + JSON.stringify(error));
  //     console.log(error);
  //   }finally {
  //     setIsLoaderVisible(false);
  //       // setInitialLoad(false);
  //   }
  // }



  // useEffect(() => {
  //   let getData = false;
  //   if(groupByFilter?.includes("Product")) {
  //     if(cubeChildExpendableRuleItems?.length > 0){
  //       getData = true;
  //     }
  //   } else if (groupByFilter?.includes("Broad")) {
  //     if(cubeChildExpendableRuleItems?.length > 0){
  //       getData = true;
  //     }
  //   }
  //   // to fetch child rows data

  //   if (getData) {
  //     const filters = mergeCustomOutputToAPIFiltersFormat(
  //       filterModuleFilters?.metrics?.custom_output,
  //       filterModuleFilters?.dimension?.custom_output,
  //       filterModuleFilters?.campaigns?.custom_output,
  //       filterModuleFilters?.topX?.custom_output,
  //     );
  //     let tempFilter = JSON.parse(JSON.stringify(filters));
  //     if(userPlatform === 'amazon'){
  //       tempFilter = ruleItemInjector(tempFilter,"dimensions", defaultDimensions(clientAccountId,cubeChildExpendableRuleItems));
  //       tempFilter = ruleItemInjector(tempFilter,"campaigns", defaultDimensions("",[excludeSBCampaignsFiltering]));
  //     }

  //     getChildProductReportData(tempFilter,currentViewType === "Comparison View").then((resultSet) => {
  //       setChildrenOne((prev) => {
  //         return { ...prev, [childDataIndex]: resultSet };
  //       });
  //       setIsLoaderVisible(false);
  //       // setInitialLoad(false);
  //     });
  //   }
  // }, [cubeChildExpendableRuleItems]);

  const calenderIconRefForCampaignlist = useRef(null);

  const closeCalender = (e) => {
    if (
      calenderIconRefForCampaignlist.current &&
      showCustomDateBox &&
      !calenderIconRefForCampaignlist.current.contains(e.target)
    ) {
      setShowCustomDateBox(false);
    }
  };

  const dateInputClickHandler = (e) => {
    setShowCustomDateBox(!showCustomDateBox);
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeCalender);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", closeCalender);
    };
  }, [showCustomDateBox]);



  useEffect(() => {
    setIsFilterVisible(filterModalInCampaignListVisibilty);
  }, [filterModalInCampaignListVisibilty]);

  useEffect(() => {
    if (!groupByFilter) return;

    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("reportType", groupByFilter);
    queryParams.set("viewtype", currentViewType);

    const dimensionsParam = (cubeQueryDimensions || []).join(",");
    if (dimensionsParam) {
      queryParams.set("analysisDimensions", dimensionsParam);
    } else {
      queryParams.delete("analysisDimensions");
    }

    const newSearch = queryParams.toString();
    const currentSearch = window.location.search.replace(/^\?/, "");
    if (newSearch === currentSearch) return;

    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}?${newSearch}`
    );
  }, [
    groupByFilter,
    currentViewType,
    cubeQueryDimensions,
  ]);

  const handleComparisonView = useCallback((isComparison) => {
    if (isComparison) {
      setCubeQueryTimeDimensions([
        {
          dimension: PlatformWiseKeyMapper[userPlatform]?.date,
          compareDateRange: [
            [startDate, endDate],
            [startDatePrevious, endDatePrevious],
          ],
        },
      ]);
      setIsLoaderVisible(true);
    } else {
      setCubeQueryTimeDimensions([
        {
          dimension: PlatformWiseKeyMapper[userPlatform]?.date,
          dateRange: [
            formatDate(calendarDate[0].startDate),
            formatDate(calendarDate[0].endDate),
          ],
        },
      ]);
      setIsLoaderVisible(true);
    }
    setisComparisonView(isComparison);
  }, [userPlatform, startDate, endDate, startDatePrevious, endDatePrevious, calendarDate]);

  // Set global header calendar comparison handler so the Compare switch shows in the header calendar.
  // Wrap in () => fn so React doesn't treat the function as a setState updater (which would call it and set state to its return value).
  useEffect(() => {
    setHeaderCalendarHandleComparisonView(() => handleComparisonView);
    setHeaderCalendarHideComparisonSwitch(false);
    return () => {
      setHeaderCalendarHandleComparisonView(null);
      setHeaderCalendarHideComparisonSwitch(false);
    };
  }, [setHeaderCalendarHandleComparisonView, setHeaderCalendarHideComparisonSwitch, handleComparisonView]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePageLimitChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };


  const sortData = (key, order) => {
    setCurrentPage(1)
    setCubeQueryOrder([
      [key, order]
    ]);
  }


 

  const handleQueryChange = (urlQueryParam) => {
    isProcessingUrlQueryRef.current = true;
    const urlQueryFilter= JSON.parse(decodeURIComponent(urlQueryParam ? urlQueryParam : "{}"));
    let filterCustomFormat = reverseMergeAPIFiltersToFilterModuleFormat(urlQueryFilter);
    if(filterCustomFormat?.metrics?.custom_output || filterCustomFormat?.dimension?.custom_output || filterCustomFormat?.campaigns?.custom_output) {
      setIsFilterApplied(true);
    }
    // Update filters state
    setFilterModuleFilters((prev)=>{
      return JSON.parse(JSON.stringify(filterCustomFormat));
    });
    // Fetch data directly with the new filters to avoid race condition
    handleDataFetch(filterCustomFormat);
    // Reset flag after state updates complete
    setTimeout(() => {
      isProcessingUrlQueryRef.current = false;
    }, 0);
    return filterCustomFormat;
  }

  function handleDynamicPageSaveFunction () {
    if(pageType === "productset") {
      if(!isFilterApplied){
        toast.error("Please apply filters to save Product Set.");
        return;
      }
    }
    const function_mapper = {
      'stoploss':handleSaveStoplossRuleFunction,
      'productset':() =>{setProductDetailsShow("PERSONAL_DETAILS")}
    }
    const functionToRun = function_mapper[pageType];
    functionToRun();
  }

  const generateStopLossHeading = (pslRuleId) => {
    return pslRuleId ? "Update" : "Create"
  }

  const handleFilterNavigate = (pageName) => {
     
    if(pageName === "STOP_LOSS" && isPlatformMatch(["flipkart"])) {
      return toast.info(`This feature is currently not supported for ${userPlatform}.`)
    }

    const isNavigatingToProductSet = pageName === "PRODUCT_SET";
    const isNavigatingToStopLoss = pageName === "STOP_LOSS";
    if (!isNavigatingToProductSet && !isNavigatingToStopLoss) {
      return;
    }

    const nextPage = isNavigatingToProductSet ? "productset" : "stoploss";
    const nextDimensions = ensureProductSetSkuDimension(
      cubeQueryDimensions || [],
      { isProductSetPage: isNavigatingToProductSet, userPlatform }
    );
    navigate(
      `/product-analytics?${buildProductAnalyticsSearch({
        reportType: groupByFilter,
        viewtype: currentViewType,
        analysisDimensions: nextDimensions,
        page: nextPage,
      })}`
    );
  }

  const selectedProductAdRows = useMemo(
    () => (newRawData || []).filter((row) => row?.isChecked),
    [newRawData]
  );
  const selectedBulkIds = useMemo(
    () => getSelectedRowIds(newRawData, bulkIdKeys),
    [newRawData, bulkIdKeys]
  );
  const showSelectAllMatching = shouldShowSelectAllMatchingBanner({
    scope: bulkScope,
    pageSelectedCount: selectedBulkIds.length,
    pageSelectableCount: hasChildAsinDimension ? newRawData.length : 0,
    totalCount: totalProductCount,
  });

  const resetProductAdBulkSelection = (rows = newRawData) => {
    const cleared = clearBulkSelection(rows);
    setNewRawData(cleared.rows);
    setBulkScope(cleared.scope);
    setBulkExcludeIds(cleared.excludeIds);
  };

  const cubeQueryDimensionsKey = (cubeQueryDimensions || []).join(",");
  const prevCubeQueryDimensionsKeyRef = useRef(cubeQueryDimensionsKey);
  useEffect(() => {
    if (!isAmazonProductAnalytics) return;
    if (prevCubeQueryDimensionsKeyRef.current === cubeQueryDimensionsKey) return;
    prevCubeQueryDimensionsKeyRef.current = cubeQueryDimensionsKey;
    setBulkScope(BULK_SCOPE.SELECTED);
    setBulkExcludeIds([]);
    setNewRawData((prev) => clearBulkSelection(prev).rows);
  }, [cubeQueryDimensionsKey, isAmazonProductAnalytics]);

  const closeBulkConfirmModal = () => {
    if (isBulkSubmitting) return;
    const shouldRefresh = isBulkSuccess;
    setBulkConfirm(null);
    setPendingBulkOperation(null);
    setPendingPopulateOperation(null);
    setShowPopulateAds(false);
    setIsBulkSuccess(false);
    if (shouldRefresh) {
      setTableRefreshNonce((nonce) => nonce + 1);
    }
  };

  const singleCheckBoxHandler = (index) => {
    if (!hasChildAsinDimension) return;
    setNewRawData((prev) => {
      const result = applyBulkRowToggle({
        rows: prev,
        index,
        scope: bulkScope,
        excludeIds: bulkExcludeIds,
        idKeys: bulkIdKeys,
      });
      setBulkScope(result.scope);
      setBulkExcludeIds(result.excludeIds);
      return result.rows;
    });
  };

  const allCheckBoxHandler = (checked) => {
    if (!hasChildAsinDimension) return;
    setNewRawData((prev) => {
      const result = applyBulkSelectAllPage({ rows: prev, checked });
      setBulkScope(result.scope);
      setBulkExcludeIds(result.excludeIds);
      return result.rows;
    });
  };

  const handleSelectAllMatching = () => {
    if (!hasChildAsinDimension) return;
    setNewRawData((prev) => {
      const result = applySelectAllMatching({ rows: prev });
      setBulkScope(result.scope);
      setBulkExcludeIds(result.excludeIds);
      return result.rows;
    });
  };

  const prepareProductAdBulkQuery = ({
    scopeOverride,
    selectedRowsOverride,
    excludeRowsOverride,
  } = {}) => {
    const lastQuery = lastInsightsQueryRef.current || {};
    const {
      offset,
      limit,
      comparison_percentage_filters,
      ...queryContext
    } = lastQuery;
    const selectedRows =
      selectedRowsOverride !== undefined
        ? selectedRowsOverride
        : selectedProductAdRows;
    const excludeRows =
      excludeRowsOverride !== undefined
        ? excludeRowsOverride
        : (newRawData || []).filter((row) =>
            bulkExcludeIds.includes(getRowBulkId(row, bulkIdKeys))
          );

    return buildBulkQuery({
      scope: scopeOverride || bulkScope,
      baseFilters: queryContext.filters || {},
      selectedRows,
      excludeRows,
      idKeys: bulkIdKeys,
      queryContext,
    });
  };

  const openStatusConfirm = ({
    status,
    rows,
    scope,
    grain = productAdGrain,
  }) => {
    const isEnable = status === "enabled";
    const isPortfolio = grain === PRODUCT_ANALYTICS_GRAIN.PORTFOLIO;
    const isSingleRow = Boolean(rows?.length);
    setIsBulkSuccess(false);
    setPendingBulkOperation({
      type: "status",
      status,
      rows,
      scope: scope || bulkScope,
      grain,
    });
    setBulkConfirm({
      actionKey: isEnable ? "Enable" : "Pause",
      title: isSingleRow
        ? isEnable
          ? "Enable ads for this row?"
          : "Pause ads for this row?"
        : isEnable
          ? "Enable ads for the selected products?"
          : "Pause ads for the selected products?",
      actionLabel: isPortfolio && isEnable
        ? "Create in every campaign/ad group"
        : isEnable
          ? "Enable"
          : "Pause",
      secondaryActionLabel:
        isPortfolio && isEnable ? "Enable existing only" : null,
      description: isPortfolio && isEnable
        ? "Create ads in every campaign and ad group in the selected portfolio(s), or only enable ads that already exist."
        : null,
      infoNote: getProductAdStatusScopeNote(grain, isEnable),
      confirmColor: isEnable ? "primary" : "error",
    });
  };

  const handleToggleStatus = (row) => {
    if (!hasChildAsinDimension || isBulkSubmitting || !row) return;
    const nextStatus = isAdStatusEnabled(row) ? "paused" : "enabled";
    openStatusConfirm({
      status: nextStatus,
      rows: [row],
      scope: BULK_SCOPE.SELECTED,
    });
  };

  const handleSelectionBarClick = (optionKey) => {
    if (optionKey === "Populate") {
      handleOpenPopulate();
      return;
    }
    if (optionKey !== "Pause" && optionKey !== "Enable") return;
    openStatusConfirm({
      status: optionKey === "Pause" ? "paused" : "enabled",
    });
  };

  const handleBulkConfirm = async (createMissingOverride) => {
    if (!bulkConfirm || !pendingBulkOperation || isBulkSubmitting) {
      setBulkConfirm(null);
      return;
    }
    const email = userDetails?.user?.email ?? localStorage.getItem("email") ?? "";
    const token = authHeader();
    const grain = pendingBulkOperation.grain || productAdGrain;
    const status = pendingBulkOperation.status;
    const operationRows = pendingBulkOperation.rows;
    const isSingleRow = Boolean(operationRows?.length);
    const operationScope = pendingBulkOperation.scope || bulkScope;
    const selectedRows = isSingleRow ? operationRows : selectedProductAdRows;
    const requestedCount = isSingleRow
      ? 1
      : getRequestedCountForBulk({
          scope: operationScope,
          selectedIdsCount: selectedBulkIds.length,
          totalCount: totalProductCount,
          excludeIdsCount: bulkExcludeIds.length,
        });

    if (requestedCount <= 0) {
      toast.info("No products selected for status update.");
      setBulkConfirm(null);
      setPendingBulkOperation(null);
      return;
    }

    const bulkPayload = prepareProductAdBulkQuery({
      scopeOverride: operationScope,
      selectedRowsOverride: selectedRows,
    });
    const createMissing =
      createMissingOverride !== undefined
        ? Boolean(createMissingOverride)
        : shouldCreateMissingByDefault(grain, status);

    const body = buildBulkAdStatusPatchBody({
      query: bulkPayload?.query,
      email,
      requestedCount,
      status,
      createMissing,
    });

    setBulkConfirm(null);
    setIsBulkSubmitting(true);
    try {
      await submitBulkAdStatusUpdate({
        clientId,
        userPlatform,
        skipEvents: true,
        body,
        token,
      });
      if (!isSingleRow) {
        resetProductAdBulkSelection();
      }
      setPendingBulkOperation(null);
      setIsBulkSuccess(true);
      setBulkConfirm({
        actionKey: "Status",
        title: "Request Submitted",
        actionLabel: "Close",
        description: null,
        secondaryActionLabel: null,
      });
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message ??
          error?.message ??
          "Failed to submit bulk ad status update."
      );
      setBulkConfirm(null);
      setPendingBulkOperation(null);
    } finally {
      setIsBulkSubmitting(false);
    }
  };

  const handleOpenPopulate = () => {
    if (!hasChildAsinDimension) {
      toast.info("Group by Child Product (ASIN) to populate ads.");
      return;
    }
    const populateCount = getRequestedCountForBulk({
      scope: bulkScope,
      selectedIdsCount: selectedBulkIds.length,
      totalCount: totalProductCount,
      excludeIdsCount: bulkExcludeIds.length,
    });
    if (populateCount <= 0) {
      toast.info("Select products or all matching filters to populate.");
      return;
    }
    setIsBulkSuccess(false);
    setPendingPopulateOperation(null);
    setBulkConfirm(null);
    setShowPopulateAds(true);
  };

  const handlePopulateModalSubmit = (operation) => {
    setPendingPopulateOperation(operation);
    setIsBulkSuccess(false);
    const isRespective = operation?.level === POPULATE_LEVEL.RESPECTIVE;
    const destinationSummary = isRespective
      ? "every ad group of each product's own campaign"
      : operation?.level === POPULATE_LEVEL.CAMPAIGN
        ? `all ad groups of ${operation?.campaignCount || 0} campaign(s)`
        : `${operation?.adgroupCount || 0} ad group(s)`;
    setBulkConfirm({
      actionKey: "Populate",
      title: "Confirm Populate Product Ads?",
      actionLabel: "Confirm",
      description: (
        <>
          Populate selected products at{" "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            {operation?.label || operation?.level}
          </Box>
          {" into "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            {destinationSummary}
          </Box>
          .
        </>
      ),
    });
  };

  const handlePopulateConfirm = async () => {
    if (!bulkConfirm || !pendingPopulateOperation || isBulkSubmitting) {
      if (isBulkSuccess) {
        setBulkConfirm(null);
        setIsBulkSuccess(false);
        setPendingPopulateOperation(null);
        setShowPopulateAds(false);
      }
      return;
    }
    const email = userDetails?.user?.email ?? localStorage.getItem("email") ?? "";
    const token = authHeader();
    const requestedCount = getRequestedCountForBulk({
      scope: bulkScope,
      selectedIdsCount: selectedBulkIds.length,
      totalCount: totalProductCount,
      excludeIdsCount: bulkExcludeIds.length,
    });
    if (requestedCount <= 0) {
      toast.info("No products selected for populate.");
      setBulkConfirm(null);
      setPendingPopulateOperation(null);
      return;
    }
    const bulkPayload = prepareProductAdBulkQuery();
    const body = buildBulkAdPopulateBody({
      query: bulkPayload?.query,
      level: pendingPopulateOperation.level,
      destinations: pendingPopulateOperation.destinations,
      campaignIds: pendingPopulateOperation.campaignIds,
      email,
      requestedCount,
    });
    setIsBulkSubmitting(true);
    try {
      await submitBulkAdPopulate({
        clientId,
        userPlatform,
        skipEvents: true,
        body,
        token,
      });
      resetProductAdBulkSelection();
      setPendingPopulateOperation(null);
      setShowPopulateAds(false);
      setIsBulkSuccess(true);
      setBulkConfirm({
        actionKey: "Populate",
        title: "Request Submitted",
        actionLabel: "Close",
        description: null,
        secondaryActionLabel: null,
      });
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message ??
          error?.message ??
          "Failed to submit populate request."
      );
      setBulkConfirm(null);
      setPendingPopulateOperation(null);
    } finally {
      setIsBulkSubmitting(false);
    }
  };

  const handleExtraDimensionChange = (dimensions = [], action) => {
    if(action === "add") {
      if (allColumns.filter((column) => column?.isDimension).length >= MAX_GROUP_BY_DIMENSION_COLUMNS) {
        toast.info(`You can add up to ${MAX_GROUP_BY_DIMENSION_COLUMNS} group-by columns.`);
        return;
      }
      setCubeQueryDimensions((prev) => {
        const uniqueDimensions = [...new Set([...(prev || []), ...(dimensions || [])])];
        return uniqueDimensions;
      });
    } else if(action === "remove") {
      setCubeQueryDimensions((prev) => prev.filter((dimension) => !dimensions.includes(dimension)));
    }
  }

  const handleSortClick = useCallback(
    (key, order) => {
      setCurrentPage(1);
      setCubeQueryOrder([[key, order]]);
    },
    [setCubeQueryOrder] // standard state setters are stable, but good to keep deps correct
  );

  useEffect(() => {
    async function fetchStopLossData() {
     await axios.get(`${process.env.REACT_APP_ADS_API}/client/${clientId}/automation-rule-set/${pslRuleId}?source=${userPlatform}&type=${STOP_LOSS_RULE_TYPE[`${userPlatform.toLowerCase()}`]}`).then((data) =>{
      let stopLossData = data.data;
      let apiFilter = {};
      let filterType = "exclusion";
      let datePreset = null;

      const hydrateStopLossFilters = (parsedQuery) => {
        const filterCustomFormat = reverseMergeAPIFiltersToFilterModuleFormat(
          parsedQuery?.query?.filters
        );
        const updatedDimension = removeRuleItemByMember(
          filterCustomFormat?.dimension,
          "VariantAnalysisTablePPMPlaceholder.profileId"
        );
        const updatedAmazonCampaign = removeRuleItemByMember(
          filterCustomFormat?.campaigns,
          "VariantAnalysisTablePPMPlaceholder.campaignFormat"
        );
        const updatedStatusDimension = removeRuleItemByMember(
          updatedDimension,
          "VariantAnalysisTablePPMPlaceholder.stop_loss_entity_status"
        );
        const updatedMyntraStatusDimension = removeRuleItemByMember(
          updatedStatusDimension,
          "stop_loss_entity_status"
        );
        filterCustomFormat.dimension = updatedMyntraStatusDimension;
        filterCustomFormat.campaigns = updatedAmazonCampaign;
        return filterCustomFormat;
      };

      if(getCubeFiltersByActionType(stopLossData?.rule_tasks, "PAUSE_PRODUCTS")){
        filterType = "exclusion";
        let parsedQuery = JSON.parse(getCubeFiltersByActionType(stopLossData?.rule_tasks, "PAUSE_PRODUCTS") ?? "{}");
        datePreset = parsedQuery?.query?.date_preset;
        setCustomDate(datePreset);
        const filterCustomFormatExclusion = hydrateStopLossFilters(parsedQuery);
        apiFilter = filterCustomFormatExclusion;
        setFilterModuleFilters(filterCustomFormatExclusion);
      } else if(getCubeFiltersByActionType(stopLossData?.rule_tasks, "ENABLE_PRODUCTS")){
        filterType = "inclusion";
        let parsedQuery = JSON.parse(getCubeFiltersByActionType(stopLossData?.rule_tasks, "ENABLE_PRODUCTS") ?? "{}");
        datePreset = parsedQuery?.query?.date_preset;
        setInclusionCustomDate(datePreset);
        const filterCustomFormatInclusion = hydrateStopLossFilters(parsedQuery);
        apiFilter = filterCustomFormatInclusion;
        setInclusionFilterModuleFilters(filterCustomFormatInclusion);
      }

      setStopLossFilterType(filterType);
      handleDataFetch(apiFilter, datePreset, filterType);
        
      setStoplossRuleDetail((prev) => {
        let data = { ...prev }
        data['name'] = stopLossData?.name;
        data['frequency'] = stopLossData?.schedule_config?.day_frequency;
        data['recommend_only'] = !stopLossData?.apply_decision;
        data['stoploss_running_days'] = stopLossData?.schedule_config?.frequency_values;
        data['max_percent_exclude'] = stopLossData?.rule_tasks?.[0]?.rule_action_config?.max_percent_exclude;
        
        return data;
    });
     }).catch((error) => {
       console.log(error);
       toast.error("Error while fetching Stoploss Rule Data. Try Again!")
     });
    }
    
    if(pslRuleId){
     fetchStopLossData();
     setIsPSLRuleFilterLoading(false);
    }
    setInitialLoad(false);
  }, [pslRuleId]);


      function capitalizeFirstLetter(string) {
        if (!string) return "";
        return string.charAt(0).toUpperCase() + string.slice(1);
      }

      const getPlaceholderText = () => {
        const labels = allColumns
          .filter((column) => column?.isDimension && column.key !== "date")
          .map((column) => column.shortTitle)
          .filter(Boolean);
        const placeholderText = `Search ${[...new Set(labels)].join(", ")}`;
        return placeholderText;
      }

      const currentSavedReport = (customSavedReports ?? []).find(
        (report) => report?.id === savedReportId
      );

      const handleSaveCustomView = async (reportName) => {
        const trimmedName = reportName?.trim();
        if (!trimmedName) return;

        const cubeFilters = mergeCustomOutputToAPIFiltersFormatWithComparisonPercentage(
          filterModuleFilters?.metrics?.custom_output,
          filterModuleFilters?.dimension?.custom_output,
          filterModuleFilters?.campaigns?.custom_output,
          filterModuleFilters?.topX?.custom_output,
          isComparisonView
            ? filterModuleFilters?.comparisonPercentage?.custom_output
            : null
        );

        try {
          const analyticsReportKey = getCustomReportKeyByPage(
            userPlatform,
            "analytics"
          );
        const pageUrlParams = new URLSearchParams({
          reportType: groupByFilter,
          viewtype: currentViewType,
          analysisDimensions: (cubeQueryDimensions || []).join(","),
        });
          await saveCustomReportByKey(clientId, analyticsReportKey, {
            reportName: trimmedName,
            cubeFilters,
          pageURL: `product-analytics?${pageUrlParams.toString()}`,
          }, userPlatform);
          await refreshCustomSavedReports?.();
          toast.success("Custom report saved successfully");
        } catch (error) {
          toast.error(
            error?.response?.data?.message ??
              error?.message ??
              "Unable to save custom report"
          );
        }
      };

      const handleUpdateCustomView = async (reportId) => {
        if (!reportId) return;
        const cubeFilters = mergeCustomOutputToAPIFiltersFormatWithComparisonPercentage(
          filterModuleFilters?.metrics?.custom_output,
          filterModuleFilters?.dimension?.custom_output,
          filterModuleFilters?.campaigns?.custom_output,
          filterModuleFilters?.topX?.custom_output,
          isComparisonView
            ? filterModuleFilters?.comparisonPercentage?.custom_output
            : null
        );
        try {
          const analyticsReportKey = getCustomReportKeyByPage(
            userPlatform,
            "analytics"
          );
          const pageUrlParams = new URLSearchParams({
            reportType: groupByFilter,
            viewtype: currentViewType,
            analysisDimensions: (cubeQueryDimensions || []).join(","),
          });
          await updateCustomReportById(
            clientId,
            analyticsReportKey,
            reportId,
            {
              reportName: currentSavedReport?.reportName ?? "Saved Report",
              cubeFilters,
              pageURL: `product-analytics?${pageUrlParams.toString()}`,
            },
            userPlatform
          );
          await refreshCustomSavedReports?.();
          toast.success("Custom report updated successfully");
        } catch (error) {
          toast.error(
            error?.response?.data?.message ??
              error?.message ??
              "Unable to update custom report"
          );
        }
      };
    


  const complexFilterConfig = {
    campaigns: FiltersCampaignDataQuadrant[userPlatform],
    measure: FiltersMeasuresDataQuadrant[userPlatform],
    dimension: FiltersDimensionDataQuadrant[userPlatform],
    topXConfig: TopXDataConfig,
  };

  const handleApplyQuickFilter = (filters) => {
    handleFilterOutput(JSON.parse(JSON.stringify(filters ?? {})));
  };

  const FilterComponent = <ComplexFilterWidget
        key="product_analytics_page"
        config={complexFilterConfig}
        campaignFilter={false}
        filters={filterModuleFilters}
        showPopupModal={showComplexFilter}
        setShowPopupModal={setShowComplexFilter}
        output={handleFilterOutput}
        prefixMember={""}
        type="page"
        sidebar={true}
        default={"metrics"}
        page={"overlay"}
        isAppliedCallback={() => {}}
        summary={"always"}
        narrowFilters={true}
        showComparisonPercentageFilter={isComparisonView}
        summaryOutput={(e) => {}}
        calloutTitle="Select your filters"
        calloutContent="+ Add Filter"
        hideFilterSummary={true}
        // calloutDescription="Add new attributes at campaign level to determine campaign funnel"
      />


const formatPlatformCursorData = (platform, cursorData = []) => {

const cursorFormatDate = (dateString) => {
    if (!dateString) return "--";
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleString("en-IN", options);
  }

  const platformKeyMap = {
    flipkart: {
      listingSync: "FK_LISTING_CSV_SYNC",
      listingUpload: "FK_LISTING_CSV_UPLOAD",
      statsSync: "FK_STATS_CSV_SYNC",
      statsUpload: "FK_STATS_CSV_UPLOAD",
    },
    myntra: {
      listingSync: "MYNTRA_LISTING_CSV_SYNC",
      listingUpload: "MYNTRA_LISTING_CSV_UPLOAD",
      statsSync: "MYNTRA_STATS_CSV_SYNC",
      statsUpload: "MYNTRA_STATS_CSV_UPLOAD",
    },
  };

  const keys = platformKeyMap[platform];
  if (!keys) return [];

  return [
    {
      title: "Listing Data",
      lastSync: cursorFormatDate(
        cursorData.find((obj) => obj?.cursor_objective === keys.listingSync)
          ?.cursor_last_attempted_date
      ),
      lastUpload: cursorFormatDate(
        cursorData.find((obj) => obj?.cursor_objective === keys.listingUpload)
          ?.cursor_last_attempted_date
      ),
      platform: platform,
    },
    {
      title: "Order Data",
      lastSync: cursorFormatDate(
        cursorData.find((obj) => obj?.cursor_objective === keys.statsSync)
          ?.cursor_last_attempted_date
      ),
      lastUpload: cursorFormatDate(
        cursorData.find((obj) => obj?.cursor_objective === keys.statsUpload)
          ?.cursor_last_attempted_date
      ),
            platform: platform,

    },
  ];
};

async function fetchPlatformCursors() {
   const baseUrl = `${process.env.REACT_APP_ADS_API}/client/${clientId}/cursor`;
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  try {
    let response;

    if (userPlatform === "flipkart") {
      response = await axios
        .get(
          `${baseUrl}?jobs=flipkart_catalog&cursor_objectives=FK_LISTING_CSV_SYNC,FK_STATS_CSV_SYNC,FK_LISTING_CSV_UPLOAD,FK_STATS_CSV_UPLOAD&source=flipkart`
        )
        .then((res) => ({
          platform: "flipkart",
          data: res.data.data,
        }))
        .catch(() => {
          toast.error("Error fetching Flipkart cursor data");
          return { platform: "flipkart", data: [] };
        });
    } else if (userPlatform === "myntra") {
      response = await axios
        .get(
          `${baseUrl}?jobs=myntra_catalog&cursor_objectives=MYNTRA_LISTING_CSV_SYNC,MYNTRA_STATS_CSV_SYNC,MYNTRA_LISTING_CSV_UPLOAD,MYNTRA_STATS_CSV_UPLOAD&source=myntra`
        )
        .then((res) => ({
          platform: "myntra",
          data: res.data.data,
        }))
        .catch(() => {
          toast.error("Error fetching Myntra cursor data");
          return { platform: "myntra", data: [] };
        });
    } else {
      return;
    }

    const formattedData = formatPlatformCursorData(
      response.platform,
      response.data || []
    );

    setCursorData({ [response.platform]: formattedData });
  } catch (error) {
    toast.error("Error fetching platform cursor data");
  }
}

  useEffect(() => {
    const init = async () => {
      const precessedDimensionData = await processFields(
        FiltersDimensionDataQuadrant[userPlatform].fields,
        clientId,
        []
      );
      FiltersDimensionDataQuadrant[userPlatform].fields = precessedDimensionData;
      const precessedMeasuresData = await processFields(
        FiltersMeasuresDataQuadrant[userPlatform].fields,
        clientId,
        []
      );
      FiltersMeasuresDataQuadrant[userPlatform].fields = precessedMeasuresData;
      const precessedAmazonData = await processFields(
        FiltersCampaignDataQuadrant[userPlatform].fields,
        clientId,
        []
      );
      FiltersCampaignDataQuadrant[userPlatform].fields = precessedAmazonData;
    };
    init();


   fetchPlatformCursors();
  }, [clientId]); 

  useEffect(() => {
    const fetchCustomAttributeDefinition = async () => {
      if (!clientId) {
        setCustomAttributeMapping({});
        return;
      }
      try {
        const baseUrl = process.env.REACT_APP_ADS_API
        const customAttributeDefinitionUrl = `${baseUrl}/client/${clientId}/custom-attribute-definition?source=${userPlatform}&entity_type=PRODUCT_INSIGHTS`;
        const response = await axios.get(customAttributeDefinitionUrl);
        setCustomAttributeMapping(response?.data?.custom_attribute_mapping ?? {});
      } catch (error) {
        setCustomAttributeMapping({});
      }
    };

    fetchCustomAttributeDefinition();
  }, [clientId, userPlatform]);

  return (
    <div
      key={`product-analytics-${savedReportId ?? "default"}`}
      className={
        dashboardSideBarVisibiltyState
          ? "main-content-container-onopen-mode"
          : "main-content-container-oncolapse-mode"
      }
      id="main-box"
    >
      <Loader
        visible={initialLoad || isCampaignsFetching || isProductSetFetching}
      ></Loader>

      {!isPageUnderDynamicSection && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography variant="h6" fontWeight={600}>
                Product Analytics
              </Typography>
              <PlatformFetchStatus
                fetchedDataStatus={[
                  {
                    name: "Flipkart",
                    icon: FlipkartIcon,
                    platform: "flipkart",
                    error: cursorData.length === 0,
                    cursorData: cursorData.flipkart || [],
                  },
                  {
                    name: "Myntra",
                    icon: MyntraIcon,
                    platform: "myntra",
                    error: cursorData.length === 0,
                    cursorData: cursorData.myntra || [],
                  },
                ]}
              />
            </Box>
            <Typography variant="body2" color="text.secondary">
              This page shows key analytics for your{" "}
              {capitalizeFirstLetter(userPlatform)} products.
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              onClick={() => handleFilterNavigate("PRODUCT_SET")}
              variant="contained"
              size="small"
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                backgroundColor: "#6759FF",
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
            >
              Create Product Set
            </Button>
            {isPlatformMatch(["amazon", "myntra"]) && (
              <Button
                onClick={() => handleFilterNavigate("STOP_LOSS")}
                variant="contained"
                size="small"
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  backgroundColor: "#6759FF",
                  boxShadow: "none",
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
              >
                Create Stop Loss
              </Button>
            )}
          </Box>
        </Box>
      )}
      {isPageUnderDynamicSection && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="d-flex align-items-center gap-2">
            <img
              height={16}
              style={{ cursor: "pointer" }}
              src={leftArrow}
              onClick={() => {
                if (window.history.length > 1) {
                  navigate(-1); // go back if history exists
                } else if (isStopLossPage) {
                  navigate("/stop-loss-list");
                } else if (isProductSetPage) {
                  navigate("/product-set-list");
                }
              }}
              alt="leftArrow"
            />
            <SectionTitle
              sectionTitleHeading={
                generateStopLossHeading(pslRuleId ?? productsetId) +
                pageTypeConstantHeading
              }
            ></SectionTitle>
          </div>
        </div>
      )}

      {!isPageUnderDynamicSection && isPlatformMatch(["amazon"]) && (
        <div className="d-flex w-100 align-items-end justify-items-between productradiobutton">
          <div className="w-100 d-flex flex-column gap-0">
            <small className="paginationtext">*SB Data Not Present</small>
            <small className="paginationtext">
              *Data is displayed only for rows with recorded impressions.
            </small>
          </div>
        </div>
      )}
      {isStopLossPage ? (
        <StopLossFilters
          filterModuleFilters={filterModuleFilters}
          inclusionFilterModuleFilters={inclusionFilterModuleFilters}
          handleFilterOutput={handleFilterOutput}
          handleInclusionFilterOutput={handleInclusionFilterOutput}
          fetchingData={isLoaderVisible}
          handleFilterApplied={() => {}}
          handleCustomDate={handleCustomDate}
          customDate={customDate}
          inclusionCustomDate={inclusionCustomDate}
          handleInclusionCustomDate={handleInclusionCustomDate}
          stoplossRuleDetail={stoplossRuleDetail}
          setStoplossRuleDetail={setStoplossRuleDetail}
          handleStoplossRuleDetail={handleStoplossRuleDetail}
          errors={errors}
          pslRuleId={pslRuleId}
          stopLossFilterType={stopLossFilterType}
          onStopLossFilterTypeChange={handleStopLossFilterTypeChange}
        />
      ) : null}
      {isProductSetPage ? (
        <ProductSetFilters
          productsetId={productsetId}
          onSave={handleSaveProductSet}
          productSetCreationId={productSetCreationId}
          show={productDetailsShow}
          isSaving={isStoplossSaving}
          handleClose={() => setProductDetailsShow(false)}
          isDataFetching={isLoaderVisible}
          filterModuleFilters={filterModuleFilters}
          handleFilterOutput={handleFilterOutput}
          productSetDetail={productSetDetail}
          // setStoplossRuleDetail={setStoplossRuleDetail}
          handleCustomDate={handleCustomDate}
          customDate={customDate}
          handleProductSetDetail={handleProductSetDetail}
          errors={errors}
          handleFilterApplied={(value) => {
            setIsFilterApplied(value);
          }}
        />
      ) : null}
      {isPageUnderDynamicSection && (
        <div className="d-flex gap-2 py-4 justify-content-end">
          {isProductSetPage ? (
            <button
              className="primary-inactive-btn"
              onClick={() => {
                if (window.history.length > 1) {
                  navigate(-1); // go back if history exists
                } else navigate("/product-set-list");
              }}
            >
              Cancel
            </button>
          ) : null}
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleDynamicPageSaveFunction}
            disabled={isStoplossSaving}
            sx={{ textTransform: "none", borderRadius: "6px", px: 2 }}
          >
            {isStoplossSaving
              ? "Saving..."
              : generateStopLossHeading(pslRuleId ?? productsetId) +
                (isStopLossPage ? " Rule" : "")}
          </Button>
        </div>
      )}
      <div>
        {/* Filter Header*/}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
            mb: 2,
            position: "relative",
            alignItems: "center",
          }}
        >
          {/* Group By Dropdown */}
          <Autocomplete
              options={groupByOptionsData || []}
              disableClearable
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Analysis by"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiInputLabel-root": {
                      fontSize: "14px",
                      color: "#333333",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#333333", // keep same color when focused
                    },
                    "& .MuiInputBase-root": {
                      height: "36px",
                      fontSize: "12px !important",
                      color: "#333333",
                    },
                    "& .MuiInputBase-input": {
                      fontSize: "12px !important",
                      color: "#333333",
                      padding: "6px 8px",
                    },
                  }}
                />
              )}
              value={
                groupByOptionsData?.find(
                  (o) => o.value === groupByFilter
                ) || null
              }
              onChange={(event, selectedOption) => {
                if (selectedOption) {
                  setCubeQueryDimensions(
                    ensureProductSetSkuDimension(
                      [...(selectedOption.dimensions || [])],
                      { isProductSetPage, userPlatform }
                    )
                  );
                  setGroupByFilter(selectedOption.value);
                  setInputValue("");
                }
              }}
              size="small"
              sx={{
                minWidth: "180px",
                "& .MuiAutocomplete-inputRoot": {
                  fontSize: "12px",
                  color: "#333333",
                },
                "& .MuiAutocomplete-input": {
                  fontSize: "12px",
                  color: "#333333",
                },
                "& .MuiSvgIcon-root": {
                  color: "#333333",
                },
              }}
              slotProps={{
                listbox: {
                  sx: {
                    maxWidth: 300,
                    overflow: "auto",
                    fontSize: "12px",
                    "& .MuiAutocomplete-option": {
                      fontSize: "12px",
                      color: "#333333",
                      padding: "6px 12px",
                      "&:hover": { backgroundColor: "#EDEDED" },
                    },
                  },
                },
              }}
            />

          {/* Search Box */}
          <TextField
            size="small"
            placeholder={getPlaceholderText()}
            variant="outlined"
            value={inputValue}
            disabled={!isTabularView || isDownloading}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setCurrentPage(1);
                setSearchValue(e.target.value);
                setSearchTrigger((prev) => prev + 1);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "16px", color: "#333333" }} />
                </InputAdornment>
              ),
              endAdornment: searchValue && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSearchValue("");
                      setInputValue("");
                    }}
                    edge="end"
                  >
                    <CloseIcon sx={{ fontSize: "16px", color: "#333333" }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              flexGrow: 1,
              "& .MuiInputBase-root": {
                height: "36px",
                fontSize: "12px",
                color: "#333333",
                "&.Mui-disabled": {
                  backgroundColor: "grey.100",
                  color: "#333333",
                },
              },
              "& .MuiInputBase-input": {
                fontSize: "12px",
                color: "#333333",
                padding: "6px 4px",
                "&.Mui-disabled": {
                  backgroundColor: "grey.100",
                  color: "#333333",
                  cursor: "not-allowed",
                },
              },
              "& .MuiInputBase-input::placeholder": {
                fontSize: "12px",
                color: "#000000",
                opacity: 0.6,
                "&.Mui-disabled": {
                  backgroundColor: "grey.100",
                  color: "#333333",
                  cursor: "not-allowed",
                },
              },
            }}
          />

          <ColumnCustomizationButton
            collections={columnCollections}
            columns={metricColumns}
            activeCollectionId={columnCollectionId}
            selectedColumnKeys={selectedMetricKeys}
            onApply={handleApplyColumnCustomization}
            onSave={handleSaveColumnCustomization}
            onSaveAs={handleSaveAsColumnCustomization}
            onRenameView={handleRenameColumnView}
            onDeleteView={handleDeleteColumnView}
            saving={isColumnCustomizationSaving}
          />

          {!isPageUnderDynamicSection && (
            <QuickFilterButton
              clientId={clientId}
              platform={userPlatform}
              pageId={QUICK_FILTER_PAGE_IDS.PRODUCT_ANALYTICS}
              filterConfig={complexFilterConfig}
              campaignFilter={false}
              narrowFilters={true}
              onApply={handleApplyQuickFilter}
            />
          )}

          {!isPageUnderDynamicSection && (
            <ToggleButton
              value="filters"
              selected={showComplexFilter}
              onChange={() => setShowComplexFilter(!showComplexFilter)}
              sx={{
                height: "36px",
                borderRadius: 1,
                px: 1.5,
                borderColor: showComplexFilter ? "grey.700" : "grey.400",
                backgroundColor: showComplexFilter ? "grey.100" : "white",
                color: "#333333",
                fontSize: "12px",
                fontWeight: 500,
                textTransform: "none",
                "&:hover": {
                  borderColor: "grey.700",
                  backgroundColor: showComplexFilter ? "grey.200" : "grey.50",
                },
                "& .MuiTypography-root": {
                  fontSize: "12px",
                  color: "#333333",
                },
                "& svg": {
                  color: "#333333",
                },
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Badge
                  overlap="circular"
                  variant="dot"
                  invisible={!isFilterApplied}
                  sx={{
                    "& .MuiBadge-badge": {
                      bgcolor: isFilterApplied ? "primary.main" : "transparent",
                    },
                  }}
                >
                  {showComplexFilter ? (
                    <FilterAlt fontSize="small" />
                  ) : (
                    <FilterAltOutlined fontSize="small" />
                  )}
                </Badge>
                <Typography fontWeight={500}>Filters</Typography>
                {showComplexFilter ? (
                  <ArrowDropUp fontSize="small" />
                ) : (
                  <ArrowDropDown fontSize="small" />
                )}
              </Stack>
            </ToggleButton>
          )}

          {/* Calendar is in global header; comparison handler set via context above */}

          {isAmazonProductAnalytics && isTabularView && !isComparisonView && (
            <Tooltip title="Bulk enable/pause CSV" arrow>
              <IconButton
                onClick={() => dispatch(campaignListActions.showUploadInGlobalAd())}
                sx={{ color: "#333333" }}
              >
                <FileUploadOutlined sx={{ fontSize: 24 }} />
              </IconButton>
            </Tooltip>
          )}

          {/* download button */}
          {isTabularView && <ExportDownloadTooltip
            autoOpen={isExportRedirectMode}
            title={
              isComparisonView
                ? "Download is available only in non-comparison view"
                : isExportRedirectMode
                  ? EXPORT_TRACK_TOOLTIP_MESSAGE
                  : EXPORT_LIMIT_TOOLTIP_MESSAGE
            }
          >
            <span>
              <IconButton
                onClick={handleDownloadButtonClick}
                disabled={isDownloading || isComparisonView}
                sx={getExportRedirectIconButtonSx(isExportRedirectMode, {
                  position: "relative",
                })}
              >
                {isDownloading ? (
                  <CircularProgress
                    size={18}
                    thickness={5}
                    sx={{
                      color: "grey.600",
                    }}
                  />
                ) : isExportRedirectMode ? (
                  <OpenInNewOutlined sx={{ fontSize: 24 }} />
                ) : (
                  <FileDownloadOutlined sx={{ fontSize: 24 }} />
                )}
              </IconButton>
            </span>
          </ExportDownloadTooltip>}

          {/* Table and Chart View Segmented Control */}
          <Box
            sx={{
              display: "flex",
              border: "1px solid",
              borderColor: "grey.400",
              borderRadius: 1,
              overflow: "hidden",
              height: 36,
            }}
          >
            <Button
              onClick={() => setIsTabularView(true)}
              startIcon={<List sx={{ fontSize: 18 }} />}
              sx={{
                minWidth: "auto",
                px: 1.5,
                py: 0.75,
                height: "100%",
                borderRadius: 0,
                borderTopLeftRadius: "4px",
                borderBottomLeftRadius: "4px",
                borderRight: "1px solid",
                borderColor: "grey.400",
                backgroundColor: isTabularView ? "rgba(103, 89, 255, 0.1)" : "white",
                color: isTabularView ? "#6759FF" : "#333333",
                fontSize: "12px",
                fontWeight: 500,
                textTransform: "none",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: isTabularView ? "rgba(103, 89, 255, 0.15)" : "grey.50",
                  boxShadow: "none",
                },
                "& .MuiSvgIcon-root": {
                  color: isTabularView ? "#6759FF" : "#333333",
                },
              }}
            >
              Table View
            </Button>
            <Button
              onClick={() => setIsTabularView(false)}
              startIcon={<PieChartOutlined sx={{ fontSize: 18 }} />}
              sx={{
                minWidth: "auto",
                px: 1.5,
                py: 0.75,
                height: "100%",
                borderRadius: 0,
                borderTopRightRadius: "4px",
                borderBottomRightRadius: "4px",
                backgroundColor: !isTabularView ? "rgba(103, 89, 255, 0.1)" : "white",
                color: !isTabularView ? "#6759FF" : "#333333",
                fontSize: "12px",
                fontWeight: 500,
                textTransform: "none",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: !isTabularView ? "rgba(103, 89, 255, 0.15)" : "grey.50",
                  boxShadow: "none",
                },
                "& .MuiSvgIcon-root": {
                  color: !isTabularView ? "#6759FF" : "#333333",
                },
              }}
            >
              Chart View
            </Button>
          </Box>

          {/* Popover */}
          {/* <Popover
            open={downloadPopoverOpen}
            anchorEl={downloadAnchorEl}
            onClose={handleCloseDownloadPopover}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <Box sx={{ p: 2, minWidth: 240 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Download Limit
              </Typography>
              <TextField
                size="small"
                fullWidth
                type="number"
                label="Enter download limit"
                value={downloadLimit}
                onChange={(e) => setDownloadLimit(Number(e.target.value))}
              />
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 1,
                }}
              >
                <Button
                  onClick={handleCloseDownloadPopover}
                  variant="outlined"
                  size="small"
                >
                  Cancel
                </Button>
                <Button onClick={handleApply} variant="contained" size="small">
                  Apply
                </Button>
              </Box>
            </Box>
          </Popover> */}
          {!isComparisonView && isTabularView && (
            <FormControlLabel
              label="Include %"
              labelPlacement="start"
              control={
                <Switch
                  size="small"
                  checked={showPercentage}
                  onChange={(e) => setShowPercentage(e.target.checked)}
                />
              }
              sx={{
                borderLeft: "1px solid #ddd", // separator line
                pl: 0.8,
                ml: 0.2,
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  color: "#333333",
                  paddingLeft: "4px",
                },
                "& .MuiSwitch-root": {
                  padding: "6px 8px",
                },
              }}
            />
          )}
        </Box>

        {showComplexFilter && FilterComponent }
        <AppliedFiltersChips
          filters={filterModuleFilters}
          config={complexFilterConfig}
          onChange={handleFilterOutput}
          onSaveReport={handleSaveCustomView}
          onUpdateReport={handleUpdateCustomView}
          currentSavedReport={currentSavedReport}
        />

        {isAmazonProductAnalytics && isTabularView && !isComparisonView && (
          <BulkActionBarV2
            open={
              selectedBulkIds.length > 0 ||
              bulkScope === BULK_SCOPE.ALL_MATCHING ||
              bulkScope === BULK_SCOPE.ALL_MATCHING_EXCEPT
            }
            scope={bulkScope}
            selectedIdsCount={selectedBulkIds.length}
            totalCount={totalProductCount}
            excludeIdsCount={bulkExcludeIds.length}
            showSelectAllMatching={showSelectAllMatching}
            onSelectAllMatching={handleSelectAllMatching}
            onClear={() => resetProductAdBulkSelection()}
            actions={[
              {
                key: "Populate",
                label: "Populate",
                variant: "outlined",
              },
              { key: "Pause", label: "Pause", variant: "outlined" },
              {
                key: "Enable",
                label: isBulkSubmitting ? "Submitting..." : "Enable",
                variant: "contained",
                color: "primary",
              },
            ]}
            onAction={handleSelectionBarClick}
          />
        )}

        {isTabularView &&
          (isStopLossPage || isProductSetPage) &&
          isPlatformMatch(["myntra", "flipkart"]) && (
            <Typography
              variant="body2"
              sx={{
                mt: 1.5,
                px: 1.5,
                py: 1,
                borderRadius: "8px",
                backgroundColor: "#F4F2FF",
                color: "#4F5366",
                fontSize: "13px",
              }}
            >
              Data is shown for the selected date range, excluding today as its attribution data is not processed accurately.
            </Typography>
          )}
       
       {isTabularView ? <> <ProductAnalyticsTable
          dataHeads={visibleTableColumns}
          dataBody={newRawData}
          isLoading={isLoaderVisible}
          orderByData={cubeQueryOrder}
          onSortClick={handleSortClick}
          summaryData={newRawSummaryData}
          showPercentage={showPercentage}
          summaryDataWithoutFilter={summaryDataWithoutFilter}
          isComparisonView={isComparisonView}
          groupByOptionsData={groupByOptionsData?.filter((option) => {
            if (option.value === groupByFilter) return false;
            if (!option?.dimensions?.length) return false;
            const isAlreadyAdded = option.dimensions.every((dimension) =>
              cubeQueryDimensions.includes(dimension)
            );
            return !isAlreadyAdded;
          })}
          onExtraGroupByChange={handleExtraDimensionChange}
          showGroupByPlusIcon={
            allColumns.filter((column) => column?.isDimension).length <
            MAX_GROUP_BY_DIMENSION_COLUMNS
          }
          showCheckbox={isAmazonProductAnalytics && !isComparisonView}
          showAdStatusSwitch={isAmazonProductAnalytics && !isComparisonView}
          selectionEnabled={hasChildAsinDimension && !isComparisonView}
          adStatusSwitchEnabled={
            hasChildAsinDimension && !isBulkSubmitting && !isComparisonView
          }
          onToggleRow={singleCheckBoxHandler}
          onToggleAll={allCheckBoxHandler}
          onToggleStatus={handleToggleStatus}
          getRowKey={(row, rowIdx) =>
            [
              getRowBulkId(row, bulkIdKeys),
              ...(cubeQueryDimensions || []).map((dimension) =>
                String(row?.[dimension] ?? "")
              ),
              rowIdx,
            ].join("::")
          }
          noDataFoundMessage={
            isStopLossPage
              ? "No products match this filter. Check your listing upload. Stop-Loss Status only populates after a listing upload."
              : "No data found for the selected filters or group by. Please try different filters or grouping options."
          }
          highlightNoDataFound={isStopLossPage}
        />
        {(totalProductCount > 0 || currentPage > 1) && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            py: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: "#4f5366",
            }}
          >
            <Typography variant="body2" sx={{ fontSize: "12px" }}>
              Page Size
            </Typography>
            <FormControl size="small" sx={{ minWidth: 80 }}>
              <Select
                value={itemsPerPage}
                onChange={handlePageLimitChange}
                disabled={isLoaderVisible}
                sx={{
                  height: 36,
                  fontSize: "12px",
                  color: "#333333",
                }}
                MenuProps={{ disableScrollLock: true }}
              >
                {PAGE_SIZE_OPTIONS.map((option) => (
                  <MenuItem
                    key={option}
                    value={option}
                    sx={{ fontSize: "12px" }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            lazyLoading={isLoaderVisible}
            hidePagination={!totalPages || totalPages === 0}
            totalItems={totalProductCount}
            itemsPerPage={itemsPerPage}
          />
        </Box>
        )}</> : <QuadrantView filterModuleFilters={filterModuleFilters} quadrantAvgValues={quadrantAvgValues} searchValue={searchValue} searchDimensions={selectedSearchDimensions} reportType={groupByFilter} viewtype={currentViewType} analysisDimensions={cubeQueryDimensions} />}
      </div>
      {isAmazonProductAnalytics && (
        <>
          <BulkActionConfirmModalV2
            open={Boolean(bulkConfirm)}
            title={bulkConfirm?.title}
            actionLabel={bulkConfirm?.actionLabel}
            description={bulkConfirm?.description}
            infoNote={bulkConfirm?.infoNote}
            secondaryActionLabel={bulkConfirm?.secondaryActionLabel}
            confirmColor={bulkConfirm?.confirmColor || "primary"}
            scope={
              pendingBulkOperation?.rows?.length
                ? BULK_SCOPE.SELECTED
                : bulkScope
            }
            selectedIdsCount={
              pendingBulkOperation?.rows?.length
                ? pendingBulkOperation.rows.length
                : selectedBulkIds.length
            }
            totalCount={totalProductCount}
            excludeIdsCount={
              pendingBulkOperation?.rows?.length ? 0 : bulkExcludeIds.length
            }
            zIndex={1500}
            isSuccess={isBulkSuccess}
            onGoToTracking={openRequestTrackingPage}
            onCancel={closeBulkConfirmModal}
            onConfirm={() => {
              if (isBulkSuccess) {
                closeBulkConfirmModal();
                return;
              }
              if (pendingPopulateOperation) {
                handlePopulateConfirm();
                return;
              }
              const grain = pendingBulkOperation?.grain || productAdGrain;
              if (
                pendingBulkOperation?.status === "enabled" &&
                grain === PRODUCT_ANALYTICS_GRAIN.PORTFOLIO
              ) {
                handleBulkConfirm(true);
                return;
              }
              handleBulkConfirm();
            }}
            onSecondaryConfirm={() => handleBulkConfirm(false)}
          />
          {showPopulateAds ? (
            <PopulateProductAdsV2
              open={showPopulateAds}
              clientId={clientId}
              respectiveEnabled={
                productAdGrain === PRODUCT_ANALYTICS_GRAIN.CAMPAIGN ||
                productAdGrain === PRODUCT_ANALYTICS_GRAIN.AD_GROUP
              }
              onClose={() => {
                if (isBulkSubmitting) return;
                setShowPopulateAds(false);
                setPendingPopulateOperation(null);
              }}
              onSubmit={handlePopulateModalSubmit}
            />
          ) : null}
          <CSVUploadModal
            show={csvUploadModalInGlobalAd}
            filterFor={"master-ads-list"}
            confirmationId={"bulk-enable-pause-csv-confirm"}
          />
        </>
      )}
    </div>
  );
};

export default ProductReport;